import React from "react";
import clsx from "clsx";
import { connect } from "react-redux";
import Datetime from "react-datetime";
import DatePicker from "react-date-picker";
import Iframe from "react-iframe";
import compose from "recompose/compose";
import { withRouter } from "react-router-dom";

import PropTypes from "prop-types";

import axios from "axios";
import { db, sendEmail, signatureRequest } from "firebase/fbConfig.js";
import moment from "moment";

import Geocode from "react-geocode";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Chat from "components/Chat";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import styles from "assets/jss/material-dashboard-pro-react/views/actionsStyle.jsx";
import ShipFullScreenMap from "../../views/Maps/ShipFullScreenMap";
import FormLabel from "@material-ui/core/FormLabel";
import FullScreenMap from "../../views/Maps/ShipFullScreenMap";

import HelloSign from "hellosign-embedded";

const Transition = (props) => {
  return <Slide direction="down" {...props} />;
};

class Form extends React.Component {
  state = {
    comment: "",
    queryString: "",
    actionAssigned: false,
    assignedError: false,
    defaultLoaded: false,
    assigningAction: "",
    cardAnimaton: "cardHidden",
    messageSent: false,
    messageError: false,
    mapDataSaved: true,
  };
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      shippingMode: "",
      pickUpServices: "",
      dropOffServices: "",
      services: "",
      items: [],
      userSet: false,
      step5: true,
      item2: false,
      item3: false,
      matchingFlights: [],
      hideFlights: false,
      radius: 200,
      flightDataLoaded: false,
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
    //console.log(this.state)
  };
  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  };
  handlePickUpDateChange = (pickUpDate) => {
    //console.log(pickUpDate._d)
    if (pickUpDate) {
      this.setState(() => ({
        pickUpDate: pickUpDate,
        pickUpAPI: moment(pickUpDate).format("YYYY-MM-DD"),
      }));
    }
  };

  handleDropOffDateChange = (dropOffDate) => {
    //console.log(dropOffDate)
    if (dropOffDate) {
      this.setState(() => ({ dropOffDate: dropOffDate }));
    }
  };

  // only make future selectable
  valid = (current) => {
    return current.isAfter(Datetime.moment().subtract(1, "day"));
  };

  handleSelectChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      pickUpDriverContactLoaded: false,
    });
    // console.log(this.state)
  };

  handleTogglePickupServices(value) {
    const { pickUpServices } = this.state;
    const currentIndex = pickUpServices.indexOf(value);
    const newPickUpServices = [...pickUpServices];

    if (currentIndex === -1) {
      newPickUpServices.push(value);
    } else {
      newPickUpServices.splice(currentIndex, 1);
    }

    this.setState({
      pickUpServices: newPickUpServices,
    });
  }

  handleToggleDropOffServices(value) {
    const { dropOffServices } = this.state;
    const currentIndex = dropOffServices.indexOf(value);
    const newDropOffServices = [...dropOffServices];

    if (currentIndex === -1) {
      newDropOffServices.push(value);
    } else {
      newDropOffServices.splice(currentIndex, 1);
    }

    this.setState({
      dropOffServices: newDropOffServices,
    });
  }

  handleToggleServices(value) {
    const { services } = this.state;
    const currentIndex = services.indexOf(value);
    const newServices = [...services];

    if (currentIndex === -1) {
      newServices.push(value);
    } else {
      newServices.splice(currentIndex, 1);
    }

    this.setState({
      services: newServices,
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    // update firestore document with PENDING and comment
    if (this.state.driverDropOff) {
      db.collection("TEST-orders")
        .doc(this.state.orderData.id)
        .set(
          {
            flightNumber: this.state.flightNumber
              ? this.state.flightNumber
              : null,
            originAirport: this.state.originAirport
              ? this.state.originAirport
              : null,
            destinationAirport: this.state.destinationAirport
              ? this.state.destinationAirport
              : null,
            driverPickUpName: this.state.driverPickUp
              ? this.state.driverPickUp.name
              : null,
            driverPickUpID: this.state.driverPickUp
              ? this.state.driverPickUp.id
              : null,
            vendorPickUpName: this.state.vendorPickUp
              ? this.state.vendorPickUp.name
              : null,
            vendorPickUpID: this.state.vendorPickUp
              ? this.state.vendorPickUp.id
              : null,
            driverDropOffName: this.state.driverDropOff
              ? this.state.driverDropOff.name
              : null,
            driverDropOffID: this.state.driverDropOff
              ? this.state.driverDropOff.id
              : null,
            vendorDropOffName: this.state.vendorDropOff
              ? this.state.vendorDropOff.name
              : null,
            vendorDropOffID: this.state.vendorDropOff
              ? this.state.vendorDropOff.id
              : null,
            status: "dispatched",
            dispatchedAt: new Date(),
          },
          { merge: true }
        )
        .then((docRef) => {
          db.collection("TEST-users")
            .doc(this.state.driverPickUp.id)
            .collection("orders")
            .doc(this.state.orderData.id)
            .set(
              {
                uid: this.state.uid ? this.state.uid : null,
                role: this.state.role ? this.state.role : null,
                status: "dispatched",
                driverType: "pickup",
                flightNumber: this.state.flightNumber
                  ? this.state.flightNumber
                  : null,
                originAirport: this.state.originAirport
                  ? this.state.originAirport
                  : null,
                destinationAirport: this.state.destinationAirport
                  ? this.state.destinationAirport
                  : null,
                driverPickUpName: this.state.driverPickUp
                  ? this.state.driverPickUp.name
                  : null,
                driverPickUpID: this.state.driverPickUp
                  ? this.state.driverPickUp.id
                  : null,
                vendorPickUpName: this.state.vendorPickUp
                  ? this.state.vendorPickUp.name
                  : null,
                vendorPickUpID: this.state.vendorPickUp
                  ? this.state.vendorPickUp.id
                  : null,
                driverDropOffName: this.state.driverDropOff
                  ? this.state.driverDropOff.name
                  : null,
                driverDropOffID: this.state.driverDropOff
                  ? this.state.driverDropOff.id
                  : null,
                vendorDropOffName: this.state.vendorDropOff
                  ? this.state.vendorDropOff.name
                  : null,
                vendorDropOffID: this.state.vendorDropOff
                  ? this.state.vendorDropOff.id
                  : null,
                originBusinessName: this.state.orderData.originBusinessName
                  ? this.state.orderData.originBusinessName
                  : null,
                originContactName: this.state.orderData.originContactName
                  ? this.state.orderData.originContactName
                  : null,
                originContactEmail: this.state.orderData.originContactEmail
                  ? this.state.orderData.originContactEmail
                  : null,
                originContactPhone: this.state.orderData.originContactPhone
                  ? this.state.orderData.originContactPhone
                  : null,
                originOpenTime: this.state.orderData.originOpenTime
                  ? this.state.orderData.originOpenTime
                  : null,
                originCloseTime: this.state.orderData.originCloseTime
                  ? this.state.orderData.originCloseTime
                  : null,
                originStartTimeWindow: this.state.orderData
                  .originStartTimeWindow
                  ? this.state.orderData.originStartTimeWindow
                  : null,
                originEndTimeWindow: this.state.orderData.originEndTimeWindow
                  ? this.state.orderData.originEndTimeWindow
                  : null,
                originAddress: this.state.orderData.originAddress
                  ? this.state.orderData.originAddress
                  : null,
                originCity: this.state.orderData.originCity
                  ? this.state.orderData.originCity
                  : null,
                originState: this.state.orderData.originState
                  ? this.state.orderData.originState
                  : null,
                originZip: this.state.orderData.originZip
                  ? this.state.orderData.originZip
                  : null,
                originType: this.state.orderData.originType
                  ? this.state.orderData.originType
                  : null,
                pickUpDate: this.state.orderData.origin.date
                  ? this.state.orderData.origin.date
                  : null,
                pickUpServices: this.state.orderData.pickUpServices
                  ? this.state.orderData.pickUpServices
                  : null,
                destinationBusinessName: this.state.orderData
                  .destinationBusinessName
                  ? this.state.orderData.destinationBusinessName
                  : null,
                destinationContactName: this.state.orderData
                  .destinationContactName
                  ? this.state.orderData.destinationContactName
                  : null,
                destinationContactEmail: this.state.orderData
                  .destinationContactEmail
                  ? this.state.orderData.destinationContactEmail
                  : null,
                destinationContactPhone: this.state.orderData
                  .destinationContactPhone
                  ? this.state.orderData.destinationContactPhone
                  : null,
                destinationOpenTime: this.state.orderData.destinationOpenTime
                  ? this.state.orderData.destinationOpenTime
                  : null,
                destinationCloseTime: this.state.orderData.destinationCloseTime
                  ? this.state.orderData.destinationCloseTime
                  : null,
                destinationStartTimeWindow: this.state.orderData
                  .destinationStartTimeWindow
                  ? this.state.orderData.destinationStartTimeWindow
                  : null,
                destinationEndTimeWindow: this.state.orderData
                  .destinationEndTimeWindow
                  ? this.state.orderData.destinationEndTimeWindow
                  : null,
                destinationAddress: this.state.orderData.destinationAddress
                  ? this.state.orderData.destinationAddress
                  : null,
                destinationCity: this.state.orderData.destinationCity
                  ? this.state.orderData.destinationCity
                  : null,
                destinationState: this.state.orderData.destinationState
                  ? this.state.orderData.destinationState
                  : null,
                destinationZip: this.state.orderData.destinationZip
                  ? this.state.orderData.destinationZip
                  : null,
                destinationType: this.state.orderData.destinationType
                  ? this.state.orderData.destinationType
                  : null,
                dropOffDate: this.state.orderData.dropOffDate
                  ? this.state.orderData.dropOffDate
                  : null,
                dropOffServices: this.state.orderData.dropOffServices
                  ? this.state.orderData.dropOffServices
                  : null,
                services: this.state.orderData.services
                  ? this.state.orderData.services
                  : null,
                unNumber: this.state.orderData.unNumber
                  ? this.state.orderData.unNumber
                  : null,
                properShippingName: this.state.orderData.properShippingName
                  ? this.state.orderData.properShippingName
                  : null,
                packaging: this.state.orderData.packaging
                  ? this.state.orderData.packaging
                  : null,
                quantity: this.state.orderData.quantity
                  ? this.state.orderData.quantity
                  : null,
                weight: this.state.orderData.weight
                  ? this.state.orderData.weight
                  : null,
                height: this.state.orderData.height
                  ? this.state.orderData.height
                  : null,
                width: this.state.orderData.width
                  ? this.state.orderData.width
                  : null,
                depth: this.state.orderData.depth
                  ? this.state.orderData.depth
                  : null,
                class: this.state.orderData.class
                  ? this.state.orderData.class
                  : null,
                deliveryType: this.state.orderData.deliveryType
                  ? this.state.orderData.deliveryType
                  : null,
                page: window.location.pathname,
                updatedAt: new Date(),
              },
              { merge: true }
            )
            .then(() => {
              db.collection("TEST-users")
                .doc(this.state.driverDropOff.id)
                .collection("orders")
                .doc(this.state.orderData.id)
                .set(
                  {
                    uid: this.state.uid ? this.state.uid : null,
                    role: this.state.role ? this.state.role : null,
                    status: "dispatched",
                    driverType: "dropoff",
                    flightNumber: this.state.flightNumber
                      ? this.state.flightNumber
                      : null,
                    originAirport: this.state.originAirport
                      ? this.state.originAirport
                      : null,
                    destinationAirport: this.state.destinationAirport
                      ? this.state.destinationAirport
                      : null,
                    driverPickUpName: this.state.driverPickUp
                      ? this.state.driverPickUp.name
                      : null,
                    driverPickUpID: this.state.driverPickUp
                      ? this.state.driverPickUp.id
                      : null,
                    vendorPickUpName: this.state.vendorPickUp
                      ? this.state.vendorPickUp.name
                      : null,
                    vendorPickUpID: this.state.vendorPickUp
                      ? this.state.vendorPickUp.id
                      : null,
                    driverDropOffName: this.state.driverDropOff
                      ? this.state.driverDropOff.name
                      : null,
                    driverDropOffID: this.state.driverDropOff
                      ? this.state.driverDropOff.id
                      : null,
                    vendorDropOffName: this.state.vendorDropOff
                      ? this.state.vendorDropOff.name
                      : null,
                    vendorDropOffID: this.state.vendorDropOff
                      ? this.state.vendorDropOff.id
                      : null,
                    originBusinessName: this.state.orderData.originBusinessName
                      ? this.state.orderData.originBusinessName
                      : null,
                    originContactName: this.state.orderData.originContactName
                      ? this.state.orderData.originContactName
                      : null,
                    originContactEmail: this.state.orderData.originContactEmail
                      ? this.state.orderData.originContactEmail
                      : null,
                    originContactPhone: this.state.orderData.originContactPhone
                      ? this.state.orderData.originContactPhone
                      : null,
                    originOpenTime: this.state.orderData.originOpenTime
                      ? this.state.orderData.originOpenTime
                      : null,
                    originCloseTime: this.state.orderData.originCloseTime
                      ? this.state.orderData.originCloseTime
                      : null,
                    originStartTimeWindow: this.state.orderData
                      .originStartTimeWindow
                      ? this.state.orderData.originStartTimeWindow
                      : null,
                    originEndTimeWindow: this.state.orderData
                      .originEndTimeWindow
                      ? this.state.orderData.originEndTimeWindow
                      : null,
                    originAddress: this.state.orderData.originAddress
                      ? this.state.orderData.originAddress
                      : null,
                    originCity: this.state.orderData.originCity
                      ? this.state.orderData.originCity
                      : null,
                    originState: this.state.orderData.originState
                      ? this.state.orderData.originState
                      : null,
                    originZip: this.state.orderData.originZip
                      ? this.state.orderData.originZip
                      : null,
                    originType: this.state.orderData.originType
                      ? this.state.orderData.originType
                      : null,
                    pickUpDate: this.state.orderData.origin.date
                      ? this.state.orderData.origin.date
                      : null,
                    pickUpServices: this.state.orderData.pickUpServices
                      ? this.state.orderData.pickUpServices
                      : null,
                    destinationBusinessName: this.state.orderData
                      .destinationBusinessName
                      ? this.state.orderData.destinationBusinessName
                      : null,
                    destinationContactName: this.state.orderData
                      .destinationContactName
                      ? this.state.orderData.destinationContactName
                      : null,
                    destinationContactEmail: this.state.orderData
                      .destinationContactEmail
                      ? this.state.orderData.destinationContactEmail
                      : null,
                    destinationContactPhone: this.state.orderData
                      .destinationContactPhone
                      ? this.state.orderData.destinationContactPhone
                      : null,
                    destinationOpenTime: this.state.orderData
                      .destinationOpenTime
                      ? this.state.orderData.destinationOpenTime
                      : null,
                    destinationCloseTime: this.state.orderData
                      .destinationCloseTime
                      ? this.state.orderData.destinationCloseTime
                      : null,
                    destinationStartTimeWindow: this.state.orderData
                      .destinationStartTimeWindow
                      ? this.state.orderData.destinationStartTimeWindow
                      : null,
                    destinationEndTimeWindow: this.state.orderData
                      .destinationEndTimeWindow
                      ? this.state.orderData.destinationEndTimeWindow
                      : null,
                    destinationAddress: this.state.orderData.destinationAddress
                      ? this.state.orderData.destinationAddress
                      : null,
                    destinationCity: this.state.orderData.destinationCity
                      ? this.state.orderData.destinationCity
                      : null,
                    destinationState: this.state.orderData.destinationState
                      ? this.state.orderData.destinationState
                      : null,
                    destinationZip: this.state.orderData.destinationZip
                      ? this.state.orderData.destinationZip
                      : null,
                    destinationType: this.state.orderData.destinationType
                      ? this.state.orderData.destinationType
                      : null,
                    dropOffDate: this.state.orderData.dropOffDate
                      ? this.state.orderData.dropOffDate
                      : null,
                    dropOffServices: this.state.orderData.dropOffServices
                      ? this.state.orderData.dropOffServices
                      : null,
                    services: this.state.orderData.services
                      ? this.state.orderData.services
                      : null,
                    unNumber: this.state.orderData.unNumber
                      ? this.state.orderData.unNumber
                      : null,
                    properShippingName: this.state.orderData.properShippingName
                      ? this.state.orderData.properShippingName
                      : null,
                    packaging: this.state.orderData.packaging
                      ? this.state.orderData.packaging
                      : null,
                    quantity: this.state.orderData.quantity
                      ? this.state.orderData.quantity
                      : null,
                    weight: this.state.orderData.weight
                      ? this.state.orderData.weight
                      : null,
                    height: this.state.orderData.height
                      ? this.state.orderData.height
                      : null,
                    width: this.state.orderData.width
                      ? this.state.orderData.width
                      : null,
                    depth: this.state.orderData.depth
                      ? this.state.orderData.depth
                      : null,
                    class: this.state.orderData.class
                      ? this.state.orderData.class
                      : null,
                    deliveryType: this.state.orderData.deliveryType
                      ? this.state.orderData.deliveryType
                      : null,
                    page: window.location.pathname,
                    updatedAt: new Date(),
                  },
                  { merge: true }
                )
                .then(() => {
                  db.collection("TEST-users")
                    .doc(this.state.orderData.uid)
                    .collection("orders")
                    .doc(this.state.orderData.id)
                    .set(
                      {
                        status: "dispatched",
                        flightNumber: this.state.orderData.flightNumber
                          ? this.state.orderData.flightNumber
                          : null,
                        updatedAt: new Date(),
                      },
                      { merge: true }
                    )
                    .then(() => {
                      db.collection("TEST-users")
                        .doc(this.state.orderData.uid)
                        .collection("orders")
                        .doc(this.state.orderData.id)
                        .set(
                          {
                            status: "dispatched",
                            flightNumber: this.state.orderData.flightNumber
                              ? this.state.orderData.flightNumber
                              : null,
                            updatedAt: new Date(),
                          },
                          { merge: true }
                        )
                        .then(async () => {
                          console.log(this.state.pickUpDriverContact.email);
                          //const email = this.props.user.email

                          let subject = `You have been dispatched an Order!`;
                          let html = `<p>Hello </p>`;
                          html += `<p>Orders #: ${this.state.orderData.id}</p>`;
                          // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                          const emails = [this.state.pickUpDriverContact.email];
                          const attatchment = true;
                          const emailReturn = await sendEmail({
                            emails,
                            subject,
                            html,
                            attatchment,
                          });
                        })
                        .then(() => {
                          window.location.reload();
                        });
                    });
                });
            })
            .catch((err) => {
              console.log(`${err}`);
            });
        })
        .catch((err) => {
          console.log(`${err}`);
        });
    } else {
      db.collection("TEST-orders")
        .doc(this.state.orderData.id)
        .set(
          {
            flightNumber: this.state.flightNumber
              ? this.state.flightNumber
              : null,
            originAirport: this.state.originAirport
              ? this.state.originAirport
              : null,
            destinationAirport: this.state.destinationAirport
              ? this.state.destinationAirport
              : null,
            driverPickUpName: this.state.driverPickUp
              ? this.state.driverPickUp.name
              : null,
            driverPickUpID: this.state.driverPickUp
              ? this.state.driverPickUp.id
              : null,
            vendorPickUpName: this.state.vendorPickUp
              ? this.state.vendorPickUp.name
              : null,
            vendorPickUpID: this.state.vendorPickUp
              ? this.state.vendorPickUp.id
              : null,
            driverDropOffName: this.state.driverDropOff
              ? this.state.driverDropOff.name
              : null,
            driverDropOffID: this.state.driverDropOff
              ? this.state.driverDropOff.id
              : null,
            vendorDropOffName: this.state.vendorDropOff
              ? this.state.vendorDropOff.name
              : null,
            vendorDropOffID: this.state.vendorDropOff
              ? this.state.vendorDropOff.id
              : null,
            status: "dispatched",
            dispatchedAt: new Date(),
          },
          { merge: true }
        )
        .then((docRef) => {
          db.collection("TEST-users")
            .doc(this.state.driverPickUp.id)
            .collection("orders")
            .doc(this.state.orderData.id)
            .set(
              {
                uid: this.state.uid ? this.state.uid : null,
                role: this.state.role ? this.state.role : null,
                status: "dispatched",
                driverType: "pickup",
                flightNumber: this.state.flightNumber
                  ? this.state.flightNumber
                  : null,
                originAirport: this.state.originAirport
                  ? this.state.originAirport
                  : null,
                destinationAirport: this.state.destinationAirport
                  ? this.state.destinationAirport
                  : null,
                driverPickUpName: this.state.driverPickUp
                  ? this.state.driverPickUp.name
                  : null,
                driverPickUpID: this.state.driverPickUp
                  ? this.state.driverPickUp.id
                  : null,
                vendorPickUpName: this.state.vendorPickUp
                  ? this.state.vendorPickUp.name
                  : null,
                vendorPickUpID: this.state.vendorPickUp
                  ? this.state.vendorPickUp.id
                  : null,
                driverDropOffName: this.state.driverDropOff
                  ? this.state.driverDropOff.name
                  : null,
                driverDropOffID: this.state.driverDropOff
                  ? this.state.driverDropOff.id
                  : null,
                vendorDropOffName: this.state.vendorDropOff
                  ? this.state.vendorDropOff.name
                  : null,
                vendorDropOffID: this.state.vendorDropOff
                  ? this.state.vendorDropOff.id
                  : null,
                originBusinessName: this.state.orderData.originBusinessName
                  ? this.state.orderData.originBusinessName
                  : null,
                originContactName: this.state.orderData.originContactName
                  ? this.state.orderData.originContactName
                  : null,
                originContactEmail: this.state.orderData.originContactEmail
                  ? this.state.orderData.originContactEmail
                  : null,
                originContactPhone: this.state.orderData.originContactPhone
                  ? this.state.orderData.originContactPhone
                  : null,
                originOpenTime: this.state.orderData.originOpenTime
                  ? this.state.orderData.originOpenTime
                  : null,
                originCloseTime: this.state.orderData.originCloseTime
                  ? this.state.orderData.originCloseTime
                  : null,
                originStartTimeWindow: this.state.orderData
                  .originStartTimeWindow
                  ? this.state.orderData.originStartTimeWindow
                  : null,
                originEndTimeWindow: this.state.orderData.originEndTimeWindow
                  ? this.state.orderData.originEndTimeWindow
                  : null,
                originAddress: this.state.orderData.originAddress
                  ? this.state.orderData.originAddress
                  : null,
                originCity: this.state.orderData.originCity
                  ? this.state.orderData.originCity
                  : null,
                originState: this.state.orderData.originState
                  ? this.state.orderData.originState
                  : null,
                originZip: this.state.orderData.originZip
                  ? this.state.orderData.originZip
                  : null,
                originType: this.state.orderData.originType
                  ? this.state.orderData.originType
                  : null,
                pickUpDate: this.state.orderData.origin.date
                  ? this.state.orderData.origin.date
                  : null,
                pickUpServices: this.state.orderData.pickUpServices
                  ? this.state.orderData.pickUpServices
                  : null,
                destinationBusinessName: this.state.orderData
                  .destinationBusinessName
                  ? this.state.orderData.destinationBusinessName
                  : null,
                destinationContactName: this.state.orderData
                  .destinationContactName
                  ? this.state.orderData.destinationContactName
                  : null,
                destinationContactEmail: this.state.orderData
                  .destinationContactEmail
                  ? this.state.orderData.destinationContactEmail
                  : null,
                destinationContactPhone: this.state.orderData
                  .destinationContactPhone
                  ? this.state.orderData.destinationContactPhone
                  : null,
                destinationOpenTime: this.state.orderData.destinationOpenTime
                  ? this.state.orderData.destinationOpenTime
                  : null,
                destinationCloseTime: this.state.orderData.destinationCloseTime
                  ? this.state.orderData.destinationCloseTime
                  : null,
                destinationStartTimeWindow: this.state.orderData
                  .destinationStartTimeWindow
                  ? this.state.orderData.destinationStartTimeWindow
                  : null,
                destinationEndTimeWindow: this.state.orderData
                  .destinationEndTimeWindow
                  ? this.state.orderData.destinationEndTimeWindow
                  : null,
                destinationAddress: this.state.orderData.destinationAddress
                  ? this.state.orderData.destinationAddress
                  : null,
                destinationCity: this.state.orderData.destinationCity
                  ? this.state.orderData.destinationCity
                  : null,
                destinationState: this.state.orderData.destinationState
                  ? this.state.orderData.destinationState
                  : null,
                destinationZip: this.state.orderData.destinationZip
                  ? this.state.orderData.destinationZip
                  : null,
                destinationType: this.state.orderData.destinationType
                  ? this.state.orderData.destinationType
                  : null,
                dropOffDate: this.state.orderData.dropOffDate
                  ? this.state.orderData.dropOffDate
                  : null,
                dropOffServices: this.state.orderData.dropOffServices
                  ? this.state.orderData.dropOffServices
                  : null,
                services: this.state.orderData.services
                  ? this.state.orderData.services
                  : null,
                unNumber: this.state.orderData.unNumber
                  ? this.state.orderData.unNumber
                  : null,
                properShippingName: this.state.orderData.properShippingName
                  ? this.state.orderData.properShippingName
                  : null,
                packaging: this.state.orderData.packaging
                  ? this.state.orderData.packaging
                  : null,
                quantity: this.state.orderData.quantity
                  ? this.state.orderData.quantity
                  : null,
                weight: this.state.orderData.weight
                  ? this.state.orderData.weight
                  : null,
                height: this.state.orderData.height
                  ? this.state.orderData.height
                  : null,
                width: this.state.orderData.width
                  ? this.state.orderData.width
                  : null,
                depth: this.state.orderData.depth
                  ? this.state.orderData.depth
                  : null,
                class: this.state.orderData.class
                  ? this.state.orderData.class
                  : null,
                deliveryType: this.state.orderData.deliveryType
                  ? this.state.orderData.deliveryType
                  : null,
                page: window.location.pathname,
                updatedAt: new Date(),
              },
              { merge: true }
            )
            .then(() => {
              db.collection("TEST-users")
                .doc(this.state.orderData.uid)
                .collection("orders")
                .doc(this.state.orderData.id)
                .set(
                  {
                    status: "dispatched",
                    flightNumber: this.state.orderData.flightNumber
                      ? this.state.orderData.flightNumber
                      : null,
                    updatedAt: new Date(),
                  },
                  { merge: true }
                )
                .then(async () => {
                  console.log(this.state.pickUpDriverContact.email);
                  //const email = this.props.user.email

                  let subject = `You have been dispatched an Order!`;
                  let html = `<p>Hello </p>`;
                  html += `<p>Orders #: ${this.state.orderData.id}</p>`;
                  // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                  const emails = [this.state.pickUpDriverContact.email];
                  const attatchment = true;
                  const emailReturn = await sendEmail({
                    emails,
                    subject,
                    html,
                    attatchment,
                  });
                })
                .then(() => {
                  window.location.reload();
                });
            });
        })
        .catch((err) => {
          console.log(`${err}`);
        });
    }
  };

  saveAsQuote = () => {
    // update firestore document with PENDING and comment
    console.log("saving quote");
    db.collection("TEST-quotes")
      .add({
        uid: this.state.uid ? this.state.uid : null,
        role: this.state.role ? this.state.role : null,
        status: "pending",
        originBusinessName: this.state.originBusinessName
          ? this.state.originBusinessName
          : null,
        originContactName: this.state.originContactName
          ? this.state.originContactName
          : null,
        originContactEmail: this.state.originContactEmail
          ? this.state.originContactEmail
          : null,
        originContactPhone: this.state.originContactPhone
          ? this.state.originContactPhone
          : null,
        originOpenTime: this.state.originOpenTime
          ? this.state.originOpenTime
          : null,
        originCloseTime: this.state.originCloseTime
          ? this.state.originCloseTime
          : null,
        originStartTimeWindow: this.state.originStartTimeWindow
          ? this.state.originStartTimeWindow
          : null,
        originEndTimeWindow: this.state.originEndTimeWindow
          ? this.state.originEndTimeWindow
          : null,
        originAddress: this.state.originAddress
          ? this.state.originAddress
          : null,
        originCity: this.state.originCity ? this.state.originCity : null,
        originState: this.state.originState ? this.state.originState : null,
        originZip: this.state.originZip ? this.state.originZip : null,
        originType: this.state.originType ? this.state.originType : null,
        pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
        pickUpServices: this.state.pickUpServices
          ? this.state.pickUpServices
          : null,
        destinationBusinessName: this.state.destinationBusinessName
          ? this.state.destinationBusinessName
          : null,
        destinationContactName: this.state.destinationContactName
          ? this.state.destinationContactName
          : null,
        destinationContactEmail: this.state.destinationContactEmail
          ? this.state.destinationContactEmail
          : null,
        destinationContactPhone: this.state.destinationContactPhone
          ? this.state.destinationContactPhone
          : null,
        destinationOpenTime: this.state.destinationOpenTime
          ? this.state.destinationOpenTime
          : null,
        destinationCloseTime: this.state.destinationCloseTime
          ? this.state.destinationCloseTime
          : null,
        destinationStartTimeWindow: this.state.destinationStartTimeWindow
          ? this.state.destinationStartTimeWindow
          : null,
        destinationEndTimeWindow: this.state.destinationEndTimeWindow
          ? this.state.destinationEndTimeWindow
          : null,
        destinationAddress: this.state.destinationAddress
          ? this.state.destinationAddress
          : null,
        destinationCity: this.state.destinationCity
          ? this.state.destinationCity
          : null,
        destinationState: this.state.destinationState
          ? this.state.destinationState
          : null,
        destinationZip: this.state.destinationZip
          ? this.state.destinationZip
          : null,
        destinationType: this.state.destinationType
          ? this.state.destinationType
          : null,
        dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
        dropOffServices: this.state.dropOffServices
          ? this.state.dropOffServices
          : null,
        services: this.state.services ? this.state.services : null,
        unNumber: this.state.unNumber ? this.state.unNumber : null,
        properShippingName: this.state.properShippingName
          ? this.state.properShippingName
          : null,
        packaging: this.state.packaging ? this.state.packaging : null,
        quantity: this.state.quantity ? this.state.quantity : null,
        weight: this.state.weight ? this.state.weight : null,
        height: this.state.height ? this.state.height : null,
        width: this.state.width ? this.state.width : null,
        depth: this.state.depth ? this.state.depth : null,
        class: this.state.class ? this.state.class : null,
        deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
        flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
        page: window.location.pathname,
        updatedAt: new Date(),
      })
      .then((docRef) => {
        db.collection("TEST-users")
          .doc(this.state.uid)
          .collection("quotes")
          .doc(docRef.id)
          .set(
            {
              uid: this.state.uid ? this.state.uid : null,
              role: this.state.role ? this.state.role : null,
              status: "pending",
              originBusinessName: this.state.originBusinessName
                ? this.state.originBusinessName
                : null,
              originContactName: this.state.originContactName
                ? this.state.originContactName
                : null,
              originContactEmail: this.state.originContactEmail
                ? this.state.originContactEmail
                : null,
              originContactPhone: this.state.originContactPhone
                ? this.state.originContactPhone
                : null,
              originOpenTime: this.state.originOpenTime
                ? this.state.originOpenTime
                : null,
              originCloseTime: this.state.originCloseTime
                ? this.state.originCloseTime
                : null,
              originStartTimeWindow: this.state.originStartTimeWindow
                ? this.state.originStartTimeWindow
                : null,
              originEndTimeWindow: this.state.originEndTimeWindow
                ? this.state.originEndTimeWindow
                : null,
              originAddress: this.state.originAddress
                ? this.state.originAddress
                : null,
              originCity: this.state.originCity ? this.state.originCity : null,
              originState: this.state.originState
                ? this.state.originState
                : null,
              originZip: this.state.originZip ? this.state.originZip : null,
              originType: this.state.originType ? this.state.originType : null,
              pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
              pickUpServices: this.state.pickUpServices
                ? this.state.pickUpServices
                : null,
              destinationBusinessName: this.state.destinationBusinessName
                ? this.state.destinationBusinessName
                : null,
              destinationContactName: this.state.destinationContactName
                ? this.state.destinationContactName
                : null,
              destinationContactEmail: this.state.destinationContactEmail
                ? this.state.destinationContactEmail
                : null,
              destinationContactPhone: this.state.destinationContactPhone
                ? this.state.destinationContactPhone
                : null,
              destinationOpenTime: this.state.destinationOpenTime
                ? this.state.destinationOpenTime
                : null,
              destinationCloseTime: this.state.destinationCloseTime
                ? this.state.destinationCloseTime
                : null,
              destinationStartTimeWindow: this.state.destinationStartTimeWindow
                ? this.state.destinationStartTimeWindow
                : null,
              destinationEndTimeWindow: this.state.destinationEndTimeWindow
                ? this.state.destinationEndTimeWindow
                : null,
              destinationAddress: this.state.destinationAddress
                ? this.state.destinationAddress
                : null,
              destinationCity: this.state.destinationCity
                ? this.state.destinationCity
                : null,
              destinationState: this.state.destinationState
                ? this.state.destinationState
                : null,
              destinationZip: this.state.destinationZip
                ? this.state.destinationZip
                : null,
              destinationType: this.state.destinationType
                ? this.state.destinationType
                : null,
              dropOffDate: this.state.dropOffDate
                ? this.state.dropOffDate
                : null,
              dropOffServices: this.state.dropOffServices
                ? this.state.dropOffServices
                : null,
              services: this.state.services ? this.state.services : null,
              unNumber: this.state.unNumber ? this.state.unNumber : null,
              properShippingName: this.state.properShippingName
                ? this.state.properShippingName
                : null,
              packaging: this.state.packaging ? this.state.packaging : null,
              quantity: this.state.quantity ? this.state.quantity : null,
              weight: this.state.weight ? this.state.weight : null,
              height: this.state.height ? this.state.height : null,
              width: this.state.width ? this.state.width : null,
              depth: this.state.depth ? this.state.depth : null,
              class: this.state.class ? this.state.class : null,
              deliveryType: this.state.deliveryType
                ? this.state.deliveryType
                : null,
              flightNumber: this.state.flightNumber
                ? this.state.flightNumber
                : null,
              page: window.location.pathname,
              updatedAt: new Date(),
            },
            { merge: true }
          )
          .then(() => {
            this.props.history.push("/quotes");
          })
          .then(() => {
            window.location.reload();
          })
          .catch((err) => {
            console.log(`${err}`);
          });
      })
      .catch((err) => {
        console.log(`${err}`);
      });
  };

  resetRequest = () => {
    window.location.reload();
  };

  setUser = (user) => {
    this.setState({
      uid: user,
      userSet: true,
    });
    console.log(this.state);
  };

  handleGeoChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
    //console.log(this.state)
  };

  getFlights = () => {
    const axios = require("axios");

    this.setState({
      matchingFlights: [],
    });

    Geocode.setApiKey("AIzaSyBDJ7-qo34RvY_mdXfK-b-ImAm96S3tzUI");

    let origin = this.state.originCity + " " + this.state.originState;
    //console.log(origin)
    // this.setState({
    //   mapDataSaved: false
    // })
    let originCoords = Geocode.fromAddress(origin).then((response) => {
      //console.log(response.results[0].geometry.location);
      this.setState({
        originCoords: response.results[0].geometry.location,
      });
      let destination =
        this.state.destinationCity + " " + this.state.destinationState;
      //console.log(destination)
      let destinationCoords = Geocode.fromAddress(destination)
        .then((response) => {
          // console.log(response.results[0].geometry.location);
          this.setState({
            destinationCoords: response.results[0].geometry.location,
          });
          //console.log(this.state);
        })
        .then((response) => {
          // console.log(this.state)
          axios({
            method: "GET",
            url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${
              this.state.originCoords.lat
            }/${this.state.originCoords.lng}/km/${this.state.radius}/16`,
            headers: {
              "content-type": "application/octet-stream",
              "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
              "x-rapidapi-key":
                "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e",
            },
            params: {
              withFlightInfoOnly: "false",
            },
          })
            .then((response) => {
              this.setState({
                originAirports: response.data,
              });
              axios({
                method: "GET",
                url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${
                  this.state.destinationCoords.lat
                }/${this.state.destinationCoords.lng}/km/${
                  this.state.radius
                }/16`,
                headers: {
                  "content-type": "application/octet-stream",
                  "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                  "x-rapidapi-key":
                    "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e",
                },
                params: {
                  withFlightInfoOnly: "false",
                },
              })
                .then((response) => {
                  this.setState({
                    destinationAirports: response.data,
                  });
                  //console.log(this.state.originAirports.items[0].icao)

                  this.state.originAirports.items.forEach((originAirport) => {
                    // console.log(originAirport.icao)
                    let originAirportID = originAirport.icao;
                    axios({
                      method: "GET",
                      url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${
                        originAirport.icao
                      }/${moment(this.state.pickUpDate).format(
                        "YYYY-MM-DD"
                      )}T00:00/${moment(this.state.pickUpDate).format(
                        "YYYY-MM-DD"
                      )}T11:59`,
                      headers: {
                        "content-type": "application/octet-stream",
                        "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                        "x-rapidapi-key":
                          "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e",
                      },
                      params: {
                        withLeg: "false",
                        direction: "Departure",
                      },
                    })
                      .then((response) => {
                        this.setState({
                          departingFlights: response.data,
                        });
                        // console.log(response.data.departures)
                        // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
                        // console.log(departingFlightsMatch)
                        let filteredDepartingFlights = this.state
                          .matchingFlights;
                        // Parse data into array like in firebase.js
                        this.state.destinationAirports.items.forEach(
                          (destinationAirport) => {
                            let departingFlights = response.data.departures.filter(
                              (flight) =>
                                flight.movement.airport.icao ===
                                destinationAirport.icao
                            );
                            // console.log(destinationAirport)
                            // console.log(departingFlights)
                            if (departingFlights.length > 0) {
                              departingFlights.forEach((flight) => {
                                let docData = flight;
                                let docObj = {
                                  ...docData,
                                  originAirport: originAirport.icao,
                                };
                                filteredDepartingFlights.push(docObj);
                              });
                            }
                          }
                        );
                        // console.log(originAirport)
                        this.setState({
                          matchingFlights: filteredDepartingFlights,
                        });
                        this.state.originAirports.items.forEach(
                          (originAirport) => {
                            // console.log(originAirport.icao)
                            let originAirportID = originAirport.icao;
                            axios({
                              method: "GET",
                              url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${
                                originAirport.icao
                              }/${moment(this.state.pickUpDate).format(
                                "YYYY-MM-DD"
                              )}T12:00/${moment(this.state.pickUpDate).format(
                                "YYYY-MM-DD"
                              )}T23:59`,
                              headers: {
                                "content-type": "application/octet-stream",
                                "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                                "x-rapidapi-key":
                                  "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e",
                              },
                              params: {
                                withLeg: "false",
                                direction: "Departure",
                              },
                            })
                              .then((response) => {
                                this.setState({
                                  departingFlights: response.data,
                                });
                                // console.log(response.data.departures)
                                // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
                                // console.log(departingFlightsMatch)
                                let filteredDepartingFlights = this.state
                                  .matchingFlights;
                                // Parse data into array like in firebase.js
                                this.state.destinationAirports.items.forEach(
                                  (destinationAirport) => {
                                    let departingFlights = response.data.departures.filter(
                                      (flight) =>
                                        flight.movement.airport.icao ===
                                        destinationAirport.icao
                                    );
                                    // console.log(destinationAirport)
                                    // console.log(departingFlights)
                                    if (departingFlights.length > 0) {
                                      departingFlights.forEach((flight) => {
                                        let docData = flight;
                                        let docObj = {
                                          ...docData,
                                          originAirport: originAirport.icao,
                                        };
                                        filteredDepartingFlights.push(docObj);
                                      });
                                    }
                                  }
                                );
                                // console.log(originAirport)
                                this.setState({
                                  matchingFlights: filteredDepartingFlights,
                                });
                                // console.log(this.state)
                              })
                              .catch((error) => {
                                console.log(error);
                              });
                          }
                        );
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  });
                })
                .catch((error) => {
                  console.log(error);
                });
              // console.log(response)
            })
            .catch((error) => {
              console.log(error);
            });
        });
    });
  };

  saveOrigin = () => {
    if (this.state.pickUpDate) {
      Geocode.setApiKey("AIzaSyBDJ7-qo34RvY_mdXfK-b-ImAm96S3tzUI");

      let origin = this.state.originCity + " " + this.state.originState;
      console.log(origin);
      this.setState({
        mapDataSaved: false,
      });
      let originCoords = Geocode.fromAddress(origin).then((response) => {
        console.log(response.results[0].geometry.location);
        this.setState({
          originCoords: response.results[0].geometry.location,
          mapDataSaved: true,
          step1: false,
          step2: true,
        });
      });
    }
  };

  saveDestination = () => {
    Geocode.setApiKey("AIzaSyBDJ7-qo34RvY_mdXfK-b-ImAm96S3tzUI");

    let destination =
      this.state.destinationCity + " " + this.state.destinationState;
    console.log(destination);
    this.setState({
      mapDataSaved: false,
    });
    let destinationCoords = Geocode.fromAddress(destination).then(
      (response) => {
        console.log(response.results[0].geometry.location);
        this.setState({
          destinationCoords: response.results[0].geometry.location,
          mapDataSaved: true,
          step2: false,
          step3: true,
        });
      }
    );
  };

  step2Back = () => {
    this.setState({
      step1: true,
      step2: false,
    });
  };

  step3Back = () => {
    this.setState({
      step2: true,
      step3: false,
    });
  };

  saveFreight = () => {
    this.setState({
      step3: false,
      step4: true,
    });
  };

  getQuote = () => {
    this.setState({
      step4: false,
      step5: true,
    });
  };
  saveAsQuote = () => {
    this.setState({
      quote: true,
    });
  };

  step4Back = () => {
    this.setState({
      step3: true,
      step4: false,
    });
  };

  step5Back = () => {
    this.setState({
      step4: true,
      step5: false,
    });
  };

  addItem = () => {
    this.setState({
      item2: false,
    });
  };

  addItem2 = () => {
    this.setState({
      item3: false,
    });
  };

  viewFreight = () => {
    this.setState({
      viewFreight: true,
    });
  };

  assignFlightNumber = (flightNumber, originAirport, destinationAirport) => {
    this.setState({
      flightNumber: flightNumber,
      originAirport: originAirport,
      destinationAirport: destinationAirport,
    });
  };

  deliveryType = (type) => {
    this.setState({
      deliveryType: type,
    });
  };

  hideFlights = () => {
    this.setState({
      hideFlights: !this.state.hideFlights,
    });
  };

  addLeg = () => {
    this.setState({
      leg1: true,
    });
  };

  addLeg2 = () => {
    this.setState({
      leg2: true,
    });
  };

  removeLeg2 = () => {
    this.setState({
      leg1: false,
    });
  };

  addLeg3 = () => {
    this.setState({
      leg3: true,
    });
  };

  confirmPickUpRate = () => {
    db.collection("TEST-orders")
      .doc(this.props.orderID)
      .set(
        {
          pickUpRateStatus: "confirmed",
          pickUpRateStatusConfirmedAt: new Date(),
        },
        { merge: true }
      )
      .then(() => {
        db.collection("TEST-users")
          .doc(this.state.orderData.dispatcherID)
          .collection("notifications")
          .add({
            text: `${
              this.state.orderData.vendorPickUpName
            } has confirmed the pick up rate for Order #${this.props.orderID}`,
            notficationType: "rateConfirmation",
            updatedAt: new Date(),
          })
          .then(async () => {
            // console.log(this.state.pickUpDriverContact.email)
            //const email = this.props.user.email

            let subject = `A rate has been confirmed!`;
            let html = `<p>Hello </p>`;
            html += `<p>Order #: ${
              this.props.orderID
            }</p><a href=https://cargo-rx-vendor.web.app/quote/${
              this.state.orderData.id
            }>Go to Order</a>`;
            // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
            const emails = [this.state.orderData.dispatcherEmail];
            const attatchment = true;
            const emailReturn = await sendEmail({
              emails,
              subject,
              html,
              attatchment,
            });
          })
          .then(() => {
            window.location.reload();
          });
      });
  };

  confirmDropOffRate = () => {
    db.collection("TEST-orders")
      .doc(this.props.orderID)
      .set(
        {
          dropOffRateStatus: "confirmed",
          dropOffRateStatusConfirmedAt: new Date(),
        },
        { merge: true }
      )
      .then(() => {
        db.collection("TEST-users")
          .doc(this.state.orderData.dispatcherID)
          .collection("notifications")
          .add({
            text: `${
              this.state.orderData.vendorDropOffName
            } has confirmed the drop off up rate for Order #${
              this.props.orderID
            }`,
            notficationType: "rateConfirmation",
            updatedAt: new Date(),
          })
          .then(async () => {
            // console.log(this.state.pickUpDriverContact.email)
            //const email = this.props.user.email

            let subject = `A rate has been confirmed!`;
            let html = `<p>Hello </p>`;
            html += `<p>Order #: ${
              this.props.orderID
            }</p><a href=https://cargo-rx-vendor.web.app/quote/${
              this.state.orderData.id
            }>Go to Order</a>`;
            // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
            const emails = [this.state.orderData.dispatcherEmail];
            const attatchment = true;
            const emailReturn = await sendEmail({
              emails,
              subject,
              html,
              attatchment,
            });
          })
          .then(() => {
            window.location.reload();
          });
      });
  };

  loadVendorsData = (id) => {
    let data = db
      .collection("TEST-vendors")
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              name: docData.name,
              id: doc.id,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((data) => {
        data;
        this.setState({
          vendorsData: data,
          vendorsDataLoaded: true,
        });
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadDriversPickUpData = (id) => {
    let data = db
      .collection("TEST-vendors")
      .doc(id)
      .collection("users")
      .where("userType", "==", "Driver")
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              name: docData.name,
              id: doc.id,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((data) => {
        //console.log(data)
        this.setState({
          driversPickUpData: data,
          driversPickUpDataLoaded: true,
        });
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadDriversDropOffData = (id) => {
    let data = db
      .collection("TEST-vendors")
      .doc(id)
      .collection("users")
      .where("userType", "==", "Driver")
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              name: docData.name,
              id: doc.id,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((data) => {
        data;
        this.setState({
          driversDropOffData: data,
          driversDropOffDataLoaded: true,
        });
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadOrdersData = (id) => {
    console.log("loading order data");
    let data = db
      .collection("TEST-orders")
      .doc(id)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            var docObj = {
              ...docData,
              id: snapshot.id,
            };
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((docObj) => {
        this.setState({
          orderData: docObj,
          orderDataLoaded: true,
        });
      });
    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadPickUpDriverContact = (id) => {
    console.log("loading order data");
    let data = db
      .collection("TEST-users")
      .doc(id)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            var docObj = {
              ...docData,
              id: snapshot.id,
            };
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((docObj) => {
        this.setState({
          pickUpDriverContact: docObj,
          pickUpDriverContactLoaded: true,
        });
      });
    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  getFlightAddress = (flightNumber) => {
    console.log(flightNumber);

    const axios = require("axios");
    Geocode.setApiKey("AIzaSyBDJ7-qo34RvY_mdXfK-b-ImAm96S3tzUI");

    axios({
      method: "GET",
      url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/${flightNumber}`,
      headers: {
        "content-type": "application/octet-stream",
        "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
        "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e",
      },
      params: {
        withLocation: "true",
        withAircraftImage: "true",
      },
    })
      .then((response) => {
        this.setState({
          flightData: response.data,
          flightDataLoaded: true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  requestPickUpSig = (signUrl) => {
    // console.log(this.state.pickUpDriverData.firstName)
    // this.setState({
    //   eSigModal: true
    // });
    this.setState({
      puLoadingDocuments: true,
      puDocumentsLoaded: false,
    });

    db.collection("TEST-orders")
      .doc(this.props.orderID)
      .set(
        {
          signatureRequested: new Date(),
        },
        { merge: true }
      )
      .then(async () => {
        console.log("requesting signature");
        // console.log(this.state.authInfo.phone)
        //const email = this.props.user.email

        // let subject = `Your CargoRx profile has been created!`
        // let html = `<p>Hello,</p>`
        // html += `Please reset yout password in the following email and sign in to the platform using the link below.`
        // html += `<a href="https://cargo-rx.web.app/pages/login-page">Sign In</a>`
        // const emails = [this.state.authInfo.email]
        // const attatchment = true;

        // let body = 'Your CargoRx profile has been created!'
        // body += `Please reset yout password sign in to the platform using the link below.`
        // body += `https://cargo-rx.web.app/pages/login-page`
        // let from = '+17205139929'
        // let to = '+1' + this.state.authInfo.phone

        // let name = this.props.user.name
        // // let vendorIndex = this.state.vendorsData.indexOf(this.props.user.vendorID)
        // let vendor = this.state.vendorsData.filter(vendor => {
        //   return vendor.id === this.props.user.vendorID
        // })
        // // console.log(vendor)
        // let title = vendor.name + " Rate Confirmation for CargoRx Order #" + this.props.orderID
        // let subject = "CargoRx Rate Confirmation for " + vendor.name
        // let message = "Please review and sign your rate confirmation to be tendered your load."
        // let signers = [
        //     {
        //       email_address: this.props.user.email,
        //       name: this.props.user.name
        //     }
        // ]
        // let docURL = "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FAir%20Pick%20Up%20Rate%20Confirmation%20Final%203.3.2020.pdf?alt=media&token=e2206f0c-3117-4c95-a9e1-718aa813aee8"
        // console.log(name)
        // console.log(title)
        // console.log(subject)
        // console.log(message)
        // console.log(signers)
        // console.log(docURL)
        // const requestSignature = await signatureRequest({
        //   name, title, subject, message, signers, docURL
        // })

        const axios = require("axios");

        axios({
          method: "POST",
          url: `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252`,
          data: {
            sandbox: 1,
            is_draft: 0,
            embedded: 1,
            title: `CargoRx Document #${this.props.orderID}`,
            message: "This is my general document message.",
            use_signer_order: 1,
            reminders: 0,
            require_all_signers: 1,
            custom_requester_name: "",
            custom_requester_email: "",
            redirect: `https://cargo-rx-vendor.web.app/order/${
              this.props.orderID
            }?pickUpConfirmed=Y`,
            redirect_decline: "https://cargo-rx-vendor.web.app/declined",
            client: "",
            expires: 1686818000,
            embedded_signing_enabled: 1,
            flexible_signing: 0,
            use_hidden_tags: 0,
            files: [
              {
                name:
                  this.state.orderData.deliveryType == "Air"
                    ? "Air Pick Up Rate Confirmation"
                    : "Ground Only Rate Confirmation",
                file_url:
                  this.state.orderData.deliveryType == "Air" ||
                  this.state.orderData.deliveryType == "Scheduled Air"
                    ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Dispatcher%20Docs%2FPick-Up%20Dispatch%20_%20Rate%20Confirmation%20(Origin%20to%20Airline)%20Final%203.20.2020.pdf?alt=media&token=dbdd4445-fdaa-4a60-93ef-b7c9c99ecd9f"
                    : "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FGround%20Only%20Rate%20Confirmation%20Final%203.3.2020.pdf?alt=media&token=f95662dd-c5ad-405f-a70a-0c8479a1faa9",
                file_id: "",
                file_base64: "",
              },
            ],
            signers: [
              {
                id: 1,
                name: this.props.user.name
                  ? this.props.user.name
                  : this.props.user.firstName
                    ? this.props.user.firstName + " " + this.props.user.lastName
                    : "",
                email: this.props.user
                  ? this.props.user.email
                  : "justin@pondata.com",
                order: 1,
                // "pin": "3874",
                message: "This is my custom message to Signer.",
                deliver_email: 0,
                language: "en",
              },
            ],
            recipients: [
              {
                name: "Justin",
                email: "development@kordspace.com",
                language: "en",
              },
              {
                name: "Vendor",
                email: this.props.user
                  ? this.props.user.email
                  : "justin@pondata.com",
                language: "en",
              },
            ],
            meta: {
              some_key: "some_value",
              another_key: "another_value",
            },
            fields: [
              [
                {
                  type: "signature",
                  x: "250",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "570"
                      : "560",
                  width: "120",
                  height: "35",
                  page: "1",
                  signer: "1",
                  name: "",
                  identifier: "unique_field_identifier_1",
                  required: 1,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "120",
                  y: "225",
                  width: "100",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Name",
                  identifier: "unique_field_identifier_6",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "Kevin Kersting",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "120",
                  y: "245",
                  width: "100",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Phone",
                  identifier: "unique_field_identifier_7",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "(303) 947-3066",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "120",
                  y: "268",
                  width: "150",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Email",
                  identifier: "unique_field_identifier_8",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "kevin.kersting@cargorx.com",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "190",
                  y: "297",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Ready Date/Time",
                  identifier: "unique_field_identifier_9",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.origin.endTimeWindow == null
                      ? String(
                          this.state.orderData.origin.date
                            ? moment(
                                this.state.orderData.origin.date.toDate()
                              ).format("MM-DD-YYYY HH:mm")
                            : " "
                        )
                      : this.state.orderData.origin.date
                        ? String(
                            moment(
                              this.state.orderData.origin.date.toDate()
                            ).format("MM-DD-YYYY")
                          ) +
                          " " +
                          (this.state.orderData.origin.startTimeWindow &&
                            String(this.state.orderData.origin.startTimeWindow))
                        : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "650",
                  y: "225",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Waybill Number",
                  identifier: "unique_field_identifier_10",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData
                    ? this.state.orderData.freightBillNumber
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "672",
                  y: "295",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Delivery Date/Time",
                  identifier: "unique_field_identifier_11",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? String(
                          moment(
                            this.state.orderData.origin.deliverBy.toDate()
                          ).format("MM-DD-YYYY HH:mm")
                        )
                      : moment(this.state.orderData.serviceETA.toDate()).format(
                          "MM-DD-YYYY HH:mm"
                        ),
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "180",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "555"
                      : "545",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Carrier Total Charges",
                  identifier: "unique_field_identifier_12",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.pickUpRate,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "130",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "405"
                      : "395",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Carrier Name",
                  identifier: "unique_field_identifier_13",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.vendorPickUpName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "170",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "430"
                      : "420",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Carrier Pro Number",
                  identifier: "unique_field_identifier_14",
                  required: 0,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "115",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "450"
                      : "440",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "phone",
                  identifier: "unique_field_identifier_15",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.pickUpVendorData.mainPhone,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "115",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "470"
                      : "460",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Email",
                  identifier: "unique_field_identifier_16",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.pickUpVendorData.email,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "180",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "493"
                      : "483",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "DOT Number",
                  identifier: "unique_field_identifier_17",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.pickUpVendorData.dotNumber,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "180",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "515"
                      : "505",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Contact Name",
                  identifier: "unique_field_identifier_18",
                  required: 0,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    (this.props.user.firstName
                      ? this.props.user.firstName
                      : " ") +
                    " " +
                    (this.props.user.lastName ? this.props.user.lastName : " "),
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "225",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "537"
                      : "527",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Pick-up Service Level",
                  identifier: "unique_field_identifier_19",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "175",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "600"
                      : "590",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Print Name",
                  identifier: "unique_field_identifier_20",
                  required: 1,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "100",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "622"
                      : "612",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Date",
                  identifier: "unique_field_identifier_21",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: String(new Date()),
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "510",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "407"
                      : "397",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_22",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.pickUpDriverData
                    ? this.state.pickUpDriverData.firstName +
                      " " +
                      this.state.pickUpDriverData.lastName
                    : this.state.orderData.pickUpDriver
                      ? this.state.orderData.pickUpDriver.firstName +
                        " " +
                        this.state.orderData.pickUpDriver.lastName
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "430"
                      : "420",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Phone",
                  identifier: "unique_field_identifier_23",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.pickUpDriverData
                    ? this.state.pickUpDriverData.cellPhone
                      ? this.state.pickUpDriverData.cellPhone
                      : this.state.pickUpDriverData.directPhone
                    : this.state.orderData.pickUpDriver
                      ? this.state.orderData.pickUpDriver.cellPhone
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "452"
                      : "442",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Email",
                  identifier: "unique_field_identifier_24",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.pickUpDriverData
                    ? this.state.pickUpDriverData.email
                    : this.state.orderData.pickUpDriver
                      ? this.state.orderData.pickUpDriver.email
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "505"
                      : "505",
                  y:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? "474"
                      : "464",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Email",
                  identifier: "unique_field_identifier_78",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.pickUpDriverData
                    ? this.state.pickUpDriverData.sta &&
                      "STA: " + this.state.pickUpDriverData.sta
                    : this.state.orderData.pickUpDriver
                      ? "STA: " + this.state.orderData.pickUpDriver.sta
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "682",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Company Name",
                  identifier: "unique_field_identifier_25",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.businessName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "125",
                  y: "705",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Address",
                  identifier: "unique_field_identifier_26",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.address,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "110",
                  y: "728",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "City",
                  identifier: "unique_field_identifier_27",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.city,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "251",
                  y: "728",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "State",
                  identifier: "unique_field_identifier_28",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.state,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "360",
                  y: "728",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Zip",
                  identifier: "unique_field_identifier_29",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.zip,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "750",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Contact name",
                  identifier: "unique_field_identifier_30",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    (this.state.orderData.origin.firstName
                      ? this.state.orderData.origin.firstName
                      : " ") +
                    " " +
                    (this.state.orderData.origin.lastName
                      ? this.state.orderData.origin.lastName
                      : " "),
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "770",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Contact Phone",
                  identifier: "unique_field_identifier_31",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.phone
                    ? this.state.orderData.origin.phone
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "790",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Contact Email",
                  identifier: "unique_field_identifier_32",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.email
                    ? this.state.orderData.origin.email
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "255",
                  y: "812",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_33",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "255",
                  y: "836",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_34",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "255",
                  y: "855",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_35",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "245",
                  y: "880",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_36",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.referenceID
                    ? this.state.orderData.origin.referenceID
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "605",
                  y: "682",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_37",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air"
                      ? (this.state.orderData.flight.airline &&
                          this.state.orderData.flight.airline.name) +
                        " " +
                        this.state.orderData.flight.originAirport
                      : this.state.orderData.deliveryType == "Scheduled Air"
                        ? this.state.orderData.originAirCarrier.businessName +
                          this.state.orderData.originAirCarrier.airCode
                        : this.state.orderData.destination.businessName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "585",
                  y: "702",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Delivery Address",
                  identifier: "unique_field_identifier_38",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air"
                      ? this.state.originAirlineDetails[0].physicalAddress
                      : this.state.orderData.deliveryType == "Scheduled Air"
                        ? this.state.orderData.originAirCarrier.address
                        : this.state.orderData.destination.address,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "510",
                  y: "725",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Delivery City",
                  identifier: "unique_field_identifier_39",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air"
                      ? this.state.orderData.deliveryType == "Scheduled Air"
                        ? this.state.originAirCarrier.city
                        : this.state.orderData.destination.city
                      : this.state.orderData.destination.city,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "760",
                  y: "725",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Delivery Zip",
                  identifier: "unique_field_identifier_40",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air"
                      ? this.state.orderData.deliveryType == "Scheduled Air"
                        ? this.state.originAirCarrier.zip
                        : this.state.orderData.destination.zip
                      : this.state.orderData.destination.zip,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "655",
                  y: "725",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Delivery State",
                  identifier: "unique_field_identifier_41",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air"
                      ? this.state.orderData.deliveryType == "Scheduled Air"
                        ? this.state.originAirCarrier.state
                        : this.state.orderData.destination.state
                      : this.state.orderData.destination.state,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "585",
                  y: "750",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Contact Name",
                  identifier: "unique_field_identifier_42",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? " "
                      : this.state.orderData.destination.firstName +
                        " " +
                        this.state.orderData.destination.firstName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "585",
                  y: "772",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Contact Phone",
                  identifier: "unique_field_identifier_43",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? " "
                      : this.state.orderData.destination.phone,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "585",
                  y: "790",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Contact Email / Account number",
                  identifier: "unique_field_identifier_44",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? this.state.orderData.originAirCarrier
                          .cargorxAccountNumber
                        ? this.state.orderData.originAirCarrier
                            .cargorxAccountNumber
                        : " "
                      : this.state.orderData.destination.email
                        ? this.state.orderData.destination.email
                        : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "660",
                  y: "810",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Booking",
                  identifier: "unique_field_identifier_45",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? this.state.orderData.bookingNumber
                        ? this.state.orderData.bookingNumber
                        : " "
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "660",
                  y: "830",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Airline Waybill Number",
                  identifier: "unique_field_identifier_46",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? this.state.orderData.airWaybillNumber
                        ? this.state.orderData.airWaybillNumber
                        : " "
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "660",
                  y: "855",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Secondary Contact Email",
                  identifier: "unique_field_identifier_47",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? this.state.orderData.origin.deliverBy
                        ? moment(
                            this.state.orderData.origin.deliverBy.toDate()
                          ).format("MM/DD/YYYY HH:mm")
                        : " "
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "645",
                  y: "877",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_48",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.referenceID
                    ? this.state.orderData.destination.referenceID
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "575",
                  y: "940",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_49",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.customExtraService
                    ? this.state.orderData.destination.customExtraService
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "575",
                  y: "965",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_50",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "205",
                  y: "940",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_51",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.customExtraService
                    ? this.state.orderData.origin.customExtraService
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "205",
                  y: "965",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_52",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "70",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_53",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].quantity,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "955",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_54",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "70",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_55",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].quantity
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "70",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_56",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].quantity
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "70",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_156",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].quantity
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "200",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_57",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].description,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "200",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_58",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].description
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "200",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_59",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].description
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "200",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_159",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].description
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "355",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_60",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].weight,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "355",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_61",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].weight
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "355",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_62",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].weight
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "355",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_162",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].weight
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "430",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_63",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].length,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "430",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_64",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].length
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "430",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_65",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].length
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "430",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_165",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].length
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_66",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].width,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_67",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].width
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_68",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].width
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_168",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].width
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "590",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_69",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].height,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "590",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_70",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].height
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "590",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_71",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].height
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "590",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_171",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].height
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "680",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_72",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].unNumber
                    ? this.state.orderData.items[0].unNumber
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "680",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_73",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].unNumber
                      ? this.state.orderData.items[1].unNumber
                      : " "
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "680",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_74",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].unNumber
                      ? this.state.orderData.items[2].unNumber
                      : " "
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "680",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_174",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].unNumber
                      ? this.state.orderData.items[3].unNumber
                      : " "
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "770",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Hazmat",
                  identifier: "unique_field_identifier_75",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].isHazmat ? "Yes" : "No",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "770",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_76",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].isHazmat
                      ? "Yes"
                      : "No"
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "770",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_77",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].isHazmat
                      ? "Yes"
                      : "No"
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "770",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_177",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].isHazmat
                      ? "Yes"
                      : "No"
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "145",
                  y: "600",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: " ",
                  identifier: "unique_field_identifier_80",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  // "value": (((this.state.orderData.items[0] ? Number(this.state.orderData.items[0].declaredValue) : 0) + (this.state.orderData.items[1] ? Number(this.state.orderData.items[1].declaredValue) : 0) + (this.state.orderData.items[2] ? Number(this.state.orderData.items[2].declaredValue) : 0) + (this.state.orderData.items[3] ? Number(this.state.orderData.items[3].declaredValue) : 0))),
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "155",
                  y: "605",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Destination Contact Phone",
                  identifier: "unique_field_identifier_82",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? this.state.pickUpDriver
                        ? this.state.pickUpDriver.name
                        : " "
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "145",
                  y: "600",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "total declared value",
                  identifier: "unique_field_identifier_85",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : ((items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0))),
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? " "
                      : (this.state.orderData.items[0]
                          ? Number(this.state.orderData.items[0].declaredValue)
                          : 0) +
                        (this.state.orderData.items[1]
                          ? Number(this.state.orderData.items[1].declaredValue)
                          : 0) +
                        (this.state.orderData.items[2]
                          ? Number(this.state.orderData.items[2].declaredValue)
                          : 0) +
                        (this.state.orderData.items[3]
                          ? Number(this.state.orderData.items[3].declaredValue)
                          : 0),
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "105",
                  y: "620",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Destination Contact Phone",
                  identifier: "unique_field_identifier_83",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? " "
                      : this.state.orderData.deliveryType == "Air" ||
                        this.state.orderData.deliveryType == "Scheduled Air"
                        ? String(new Date())
                        : " ",
                  options: [],
                  group: "",
                },
              ],
            ],
          },
          // "params": {
          //   "withFlightInfoOnly": "false"
          // }
        }).then(
          (response) => {
            console.log(response);
            this.setState({
              signingURL: response.data.signers[0].embedded_signing_url,
              signatureURLLoaded: true,
              puDocumentsLoaded: true,
            });
            db.collection("TEST-orders")
              .doc(this.props.orderID)
              .set(
                {
                  pickUpRateConfirmHash: response.data.document_hash,
                },
                { merge: true }
              )
              .then(
                () => {
                  console.log(response);
                  window.location.replace(this.state.signingURL);
                },
                (error) => {
                  console.log(error);
                }
              );
          },
          (error) => {
            console.log(error);
          }
        );
      })
      .then(async () => {
        //   console.log("resetting password")
        //  const email = this.state.authInfo.email
        // let subject = `Your CargoRx profile has been created!`
        // let html = `<p>Hello,</p>`
        // html += `Please reset yout password in the following email and sign in to the platform using the link below.`
        // html += `<a href="https://cargo-rx.web.app/pages/login-page">Sign In</a>`
        // const emails = [this.state.authInfo.email]
        // const attatchment = true;
        // const emailReturn = await sendEmail({
        //     emails,
        //     subject,
        //     html
        //   })
      })
      .then(() => {
        // window.location.reload()
      });
  };

  requestDropOffSig = (signUrl) => {
    this.setState({
      doLoadingDocuments: true,
      doDocumentsLoaded: false,
    });

    // this.setState({
    //   eSigModal: true
    // });

    db.collection("TEST-orders")
      .doc(this.props.orderID)
      .set(
        {
          signatureRequested: new Date(),
        },
        { merge: true }
      )
      .then(async () => {
        console.log("requesting signature");
        // console.log(this.state.authInfo.phone)
        //const email = this.props.user.email

        // let subject = `Your CargoRx profile has been created!`
        // let html = `<p>Hello,</p>`
        // html += `Please reset yout password in the following email and sign in to the platform using the link below.`
        // html += `<a href="https://cargo-rx.web.app/pages/login-page">Sign In</a>`
        // const emails = [this.state.authInfo.email]
        // const attatchment = true;

        // let body = 'Your CargoRx profile has been created!'
        // body += `Please reset yout password sign in to the platform using the link below.`
        // body += `https://cargo-rx.web.app/pages/login-page`
        // let from = '+17205139929'
        // let to = '+1' + this.state.authInfo.phone

        // let name = this.props.user.name
        // // let vendorIndex = this.state.vendorsData.indexOf(this.props.user.vendorID)
        // let vendor = this.state.vendorsData.filter(vendor => {
        //   return vendor.id === this.props.user.vendorID
        // })
        // // console.log(vendor)
        // let title = vendor.name + " Rate Confirmation for CargoRx Order #" + this.props.orderID
        // let subject = "CargoRx Rate Confirmation for " + vendor.name
        // let message = "Please review and sign your rate confirmation to be tendered your load."
        // let signers = [
        //     {
        //       email_address: this.props.user.email,
        //       name: this.props.user.name
        //     }
        // ]
        // let docURL = "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FAir%20Pick%20Up%20Rate%20Confirmation%20Final%203.3.2020.pdf?alt=media&token=e2206f0c-3117-4c95-a9e1-718aa813aee8"
        // console.log(name)
        // console.log(title)
        // console.log(subject)
        // console.log(message)
        // console.log(signers)
        // console.log(docURL)
        // const requestSignature = await signatureRequest({
        //   name, title, subject, message, signers, docURL
        // })

        const axios = require("axios");

        axios({
          method: "POST",
          url: `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252`,
          data: {
            sandbox: 1,
            is_draft: 0,
            embedded: 1,
            title: `CargoRx Document #${this.props.orderID}`,
            message: "This is my general document message.",
            use_signer_order: 1,
            reminders: 1,
            require_all_signers: 1,
            custom_requester_name: "",
            custom_requester_email: "",
            redirect: `https://cargo-rx-vendor.web.app/order/${
              this.props.orderID
            }?dropOffConfirmed=Y`,
            redirect_decline: "https://cargo-rx-vendor.web.app/declined",
            client: "",
            expires: 1686818000,
            embedded_signing_enabled: 1,
            flexible_signing: 0,
            use_hidden_tags: 0,
            files: [
              {
                name: "Air Drop Off Rate Confirmation",
                file_url:
                  "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FDelivery%20Vendor%20Dispatcher%20Docs%2FPick-Up%20Dispatch%20_%20Rate%20Confirmation%20(Airline%20to%20Destination)%20Final%203.20.2020%20(1).pdf?alt=media&token=6a55fc93-3f64-49af-a6f4-a6b88185dcac",
                file_id: "",
                file_base64: "",
              },
            ],
            signers: [
              {
                id: 1,
                name: "Vendor Signer",
                email: this.props.user
                  ? this.props.user.email
                  : "justin@pondata.com",
                order: 1,
                // "pin": "3874",
                message: "This is my custom message to Signer.",
                deliver_email: "",
                language: "en",
              },
            ],
            recipients: [
              {
                name: "Justin",
                email: "development@kordspace.com",
                language: "en",
              },
              {
                name: "Vendor",
                email: this.props.user
                  ? this.props.user.email
                  : "justin@pondata.com",
                language: "en",
              },
            ],
            meta: {
              some_key: "some_value",
              another_key: "another_value",
            },
            fields: [
              [
                {
                  type: "signature",
                  x: "250",
                  y: "560",
                  width: "120",
                  height: "35",
                  page: "1",
                  signer: "1",
                  name: "",
                  identifier: "unique_field_identifier_1",
                  required: 1,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "120",
                  y: "225",
                  width: "100",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Name",
                  identifier: "unique_field_identifier_6",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "Kevin Kersting",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "120",
                  y: "245",
                  width: "100",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Phone",
                  identifier: "unique_field_identifier_7",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "(303) 947-3066",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "120",
                  y: "268",
                  width: "150",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Email",
                  identifier: "unique_field_identifier_8",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "kevin.kersting@cargorx.com",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "190",
                  y: "297",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Ready Date/Time",
                  identifier: "unique_field_identifier_9",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: moment(
                    this.state.orderData.destination.deliverBy.toDate()
                  ).format("MM/DD/YYYY HH:mm"),
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "650",
                  y: "225",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Waybill Number",
                  identifier: "unique_field_identifier_10",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData
                    ? this.state.orderData.freightBillNumber
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "672",
                  y: "295",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Delivery Date/Time",
                  identifier: "unique_field_identifier_11",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: moment(
                    this.state.orderData.serviceETA.toDate()
                  ).format("MM/DD/YYYY HH:mm"),
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "180",
                  y: "555",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Carrier Total Charges",
                  identifier: "unique_field_identifier_12",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.dropOffRate,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "130",
                  y: "405",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Carrier Name",
                  identifier: "unique_field_identifier_13",
                  required: 1,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.dropOffVendorData.name
                    ? this.state.dropOffVendorData.name
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "170",
                  y: "430",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Carrier Pro Number",
                  identifier: "unique_field_identifier_14",
                  required: 0,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "115",
                  y: "450",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "phone",
                  identifier: "unique_field_identifier_15",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.dropOffVendorData.mainPhone
                    ? this.state.dropOffVendorData.mainPhone
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "115",
                  y: "470",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Email",
                  identifier: "unique_field_identifier_16",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.dropOffVendorData.email
                    ? this.state.dropOffVendorData.email
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "180",
                  y: "493",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "DOT Number",
                  identifier: "unique_field_identifier_17",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.dropOffVendorData.dotNumber
                    ? this.state.dropOffVendorData.dotNumber
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "180",
                  y: "515",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Contact Name",
                  identifier: "unique_field_identifier_18",
                  required: 0,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "225",
                  y: "537",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Pick-up Service Level",
                  identifier: "unique_field_identifier_19",
                  required: 0,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "175",
                  y: "600",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Print Name",
                  identifier: "unique_field_identifier_20",
                  required: 1,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "100",
                  y: "622",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Date",
                  identifier: "unique_field_identifier_21",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: String(new Date()),
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "510",
                  y: "407",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_22",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.dropOffDriverData
                    ? this.state.dropOffDriverData.firstName +
                      " " +
                      this.state.dropOffDriverData.lastName
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y: "430",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Phone",
                  identifier: "unique_field_identifier_23",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.dropOffDriverData
                    ? this.state.dropOffDriverData.cellPhone
                      ? this.state.dropOffDriverData.cellPhone
                      : this.state.dropOffDriverData.directPhone
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y: "452",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Email",
                  identifier: "unique_field_identifier_24",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.dropOffDriverData
                    ? this.state.dropOffDriverData.email
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "682",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Company Name",
                  identifier: "unique_field_identifier_25",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  // "value": this.state.orderData.flight ? (this.state.orderData.flight.airline.name + " " + this.state.orderData.flight.movement.airport.icao) : " ",
                  value:
                    this.state.orderData.deliveryType == "Air"
                      ? this.state.orderData.flight
                        ? this.state.orderData.flight.airline.name +
                          " " +
                          this.state.orderData.flight.movement.airport.icao
                        : " "
                      : this.state.orderData.deliveryType == "Scheduled Air"
                        ? this.state.orderData.destinationAirCarrier
                            .businessName +
                          " " +
                          this.state.orderData.destinationAirCarrier.airCode
                        : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "125",
                  y: "705",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Address",
                  identifier: "unique_field_identifier_26",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  // "value": this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] && this.state.destinationAirlineDetails[0].physicalAddress) : " ",
                  value:
                    this.state.orderData.deliveryType == "Air"
                      ? this.state.destinationAirlineDetails
                        ? this.state.destinationAirlineDetails[0]
                          ? this.state.destinationAirlineDetails[0]
                              .physicalAddress
                            ? this.state.destinationAirlineDetails[0]
                                .physicalAddress
                            : " "
                          : " "
                        : " "
                      : this.state.orderData.deliveryType == "Scheduled Air"
                        ? this.state.orderData.destinationAirCarrier.address
                        : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "110",
                  y: "728",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "City",
                  identifier: "unique_field_identifier_27",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  // "value": this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] && this.state.destinationAirlineDetails[0].physicalCity) : " ",
                  value:
                    this.state.orderData.deliveryType == "Air"
                      ? this.state.destinationAirlineDetails
                        ? this.state.destinationAirlineDetails[0]
                          ? this.state.destinationAirlineDetails[0].physicalCity
                            ? this.state.destinationAirlineDetails[0]
                                .physicalCity
                            : " "
                          : " "
                        : " "
                      : this.state.orderData.deliveryType == "Scheduled Air"
                        ? this.state.orderData.destinationAirCarrier.city
                        : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "251",
                  y: "728",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "State",
                  identifier: "unique_field_identifier_28",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  // "value": this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] && this.state.destinationAirlineDetails[0].physicalState) : " ",
                  value:
                    this.state.orderData.deliveryType == "Air"
                      ? this.state.destinationAirlineDetails
                        ? this.state.destinationAirlineDetails[0]
                          ? this.state.destinationAirlineDetails[0]
                              .physicalState
                            ? this.state.destinationAirlineDetails[0]
                                .physicalState
                            : " "
                          : " "
                        : " "
                      : this.state.orderData.deliveryType == "Scheduled Air"
                        ? this.state.orderData.destinationAirCarrier.state
                        : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "360",
                  y: "728",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Zip",
                  identifier: "unique_field_identifier_29",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  // "value": this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] && this.state.destinationAirlineDetails[0].physicalZip) : " ",
                  value:
                    this.state.orderData.deliveryType == "Air"
                      ? this.state.destinationAirlineDetails
                        ? this.state.destinationAirlineDetails[0]
                          ? this.state.destinationAirlineDetails[0].physicalZip
                            ? this.state.destinationAirlineDetails[0]
                                .physicalZip
                            : " "
                          : " "
                        : " "
                      : this.state.orderData.deliveryType == "Scheduled Air"
                        ? this.state.orderData.destinationAirCarrier.zip
                        : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "750",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Contact name",
                  identifier: "unique_field_identifier_30",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? this.state.orderData.originAirCarrier
                          .cargorxAccountNumber
                        ? this.state.orderData.originAirCarrier
                            .cargorxAccountNumber
                        : " "
                      : this.state.orderData.destination.firstName +
                        " " +
                        this.state.orderData.destination.lastName
                        ? this.state.orderData.destination.firstName +
                          " " +
                          this.state.orderData.destination.lastName
                        : " ",
                  // "value": this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] && (this.state.destinationAirlineDetails[0].firstName + " " + this.state.destinationAirlineDetails[0].lastName)) : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "772",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_43",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? this.state.orderData.flightNumber
                        ? this.state.orderData.flightNumber
                        : " "
                      : " ",
                  // "value": this.state.orderData.destination.phone,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "200",
                  y: "812",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_44",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  // "value": this.state.orderData.destination.email,
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? this.state.orderData.airWaybillNumber
                        ? this.state.orderData.airWaybillNumber
                        : " "
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "832",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_45",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? this.state.orderData.bookingNumber
                        ? this.state.orderData.bookingNumber
                        : " "
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "790",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Contact Email",
                  identifier: "unique_field_identifier_32",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  // "value": this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] && this.state.destinationAirlineDetails[0].email) : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "255",
                  y: "812",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_33",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "255",
                  y: "836",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_34",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "255",
                  y: "855",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_35",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "245",
                  y: "880",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_36",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "id",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "605",
                  y: "682",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Drop off Business name",
                  identifier: "unique_field_identifier_37",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.businessName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "585",
                  y: "702",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Drop off address",
                  identifier: "unique_field_identifier_38",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.address,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "510",
                  y: "725",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Drop off city",
                  identifier: "unique_field_identifier_39",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.city,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "760",
                  y: "725",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Drop off zip",
                  identifier: "unique_field_identifier_40",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.zip,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "655",
                  y: "725",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Drop off state",
                  identifier: "unique_field_identifier_41",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.state,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "645",
                  y: "877",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_48",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.referenceID,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "575",
                  y: "940",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_49",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.customExtraService
                    ? this.state.orderData.destination.customExtraService
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "575",
                  y: "965",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_50",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "205",
                  y: "940",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_51",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "205",
                  y: "965",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_52",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "S ",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "70",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_53",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].quantity,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "185",
                  y: "955",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_54",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "70",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_55",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].quantity
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "70",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_56",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].quantity
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "70",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_156",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].quantity
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "200",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_57",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].description,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "200",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_58",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].description
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "200",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_59",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].description
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "200",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_159",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].description
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "355",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_60",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].weight,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "355",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_61",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].weight
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "355",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_62",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].weight
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "355",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_162",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].weight
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "430",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_63",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].length,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "430",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_64",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].length
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "430",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_65",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].length
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "430",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_165",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].length
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_66",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].width,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_67",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].width
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_68",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].width
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "515",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_168",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].width
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "590",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_69",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].height,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "590",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_70",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].height
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "590",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_71",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].height
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "590",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_171",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].height
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "680",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_72",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].unNumber
                    ? this.state.orderData.items[0].unNumber
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "680",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_73",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].unNumber
                      ? this.state.orderData.items[1].unNumber
                      : " "
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "680",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_74",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].unNumber
                      ? this.state.orderData.items[2].unNumber
                      : " "
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "680",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_174",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].unNumber
                      ? this.state.orderData.items[3].unNumber
                      : " "
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "770",
                  y: "236",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Hazmat",
                  identifier: "unique_field_identifier_75",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].isHazmat ? "Yes" : "No",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "770",
                  y: "256",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_76",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].isHazmat
                      ? "Yes"
                      : "No"
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "770",
                  y: "276",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_77",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[2]
                    ? this.state.orderData.items[2].isHazmat
                      ? "Yes"
                      : "No"
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "770",
                  y: "296",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Driver name",
                  identifier: "unique_field_identifier_177",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[3]
                    ? this.state.orderData.items[3].isHazmat
                      ? "Yes"
                      : "No"
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "145",
                  y: "600",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: " ",
                  identifier: "unique_field_identifier_80",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  // "value": (((this.state.orderData.items[0] ? Number(this.state.orderData.items[0].declaredValue) : 0) + (this.state.orderData.items[1] ? Number(this.state.orderData.items[1].declaredValue) : 0) + (this.state.orderData.items[2] ? Number(this.state.orderData.items[2].declaredValue) : 0) + (this.state.orderData.items[3] ? Number(this.state.orderData.items[3].declaredValue) : 0))),
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "155",
                  y: "605",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Destination Contact Phone",
                  identifier: "unique_field_identifier_82",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.deliveryType == "Air" ||
                    this.state.orderData.deliveryType == "Scheduled Air"
                      ? this.state.pickUpDriver
                        ? this.state.pickUpDriver.name
                        : " "
                      : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "145",
                  y: "600",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "total declared value",
                  identifier: "unique_field_identifier_85",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : ((items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0))),
                  // "value": (this.state.orderData.items[0] ? Number(this.state.orderData.items[0].declaredValue) : 0) + (this.state.orderData.items[1] ? Number(this.state.orderData.items[1].declaredValue) : 0) + (this.state.orderData.items[2] ? Number(this.state.orderData.items[2].declaredValue) : 0) + (this.state.orderData.items[3] ? Number(this.state.orderData.items[3].declaredValue) : 0),
                  value: " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "105",
                  y: "620",
                  width: "300",
                  height: "17",
                  page: "2",
                  signer: "1",
                  name: "Destination Contact Phone",
                  identifier: "unique_field_identifier_83",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: " ",
                  // "value": (this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? String(new Date()) : " ",
                  options: [],
                  group: "",
                },
              ],
            ],
          },
          // "params": {
          //   "withFlightInfoOnly": "false"
          // }
        }).then(
          (response) => {
            console.log(response);
            this.setState({
              signingURL: response.data.signers[0].embedded_signing_url,
              signatureURLLoaded: true,
              doDocumentsLoaded: true,
            });
            db.collection("TEST-orders")
              .doc(this.props.orderID)
              .set(
                {
                  dropOffRateConfirmHash: response.data.document_hash,
                },
                { merge: true }
              )
              .then(
                () => {
                  console.log(response);
                  window.location.replace(this.state.signingURL);
                },
                (error) => {
                  console.log(error);
                }
              );
          },
          (error) => {
            console.log(error);
          }
        );
      })
      .then(async () => {
        //   console.log("resetting password")
        //  const email = this.state.authInfo.email
        // let subject = `Your CargoRx profile has been created!`
        // let html = `<p>Hello,</p>`
        // html += `Please reset yout password in the following email and sign in to the platform using the link below.`
        // html += `<a href="https://cargo-rx.web.app/pages/login-page">Sign In</a>`
        // const emails = [this.state.authInfo.email]
        // const attatchment = true;
        // const emailReturn = await sendEmail({
        //     emails,
        //     subject,
        //     html
        //   })
      })
      .then(() => {
        // window.location.reload()
      });
  };

  requestWaybillSig = (signUrl) => {
    // this.setState({
    //   eSigModal: true
    // });

    db.collection("TEST-orders")
      .doc(this.props.orderID)
      .set(
        {
          signatureRequested: new Date(),
        },
        { merge: true }
      )
      .then(async () => {
        console.log("requesting signature");

        const axios = require("axios");

        axios({
          method: "POST",
          url: `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252`,
          data: {
            sandbox: 1,
            is_draft: 0,
            embedded: 1,
            title: `CargoRx Document House Waybill #${this.props.orderID}`,
            message: "This is my general document message.",
            use_signer_order: 0,
            reminders: 1,
            require_all_signers: 1,
            custom_requester_name: "",
            custom_requester_email: "",
            redirect: `https://cargo-rx-vendor.web.app/order/${
              this.props.orderID
            }`,
            redirect_decline: "https://cargo-rx-vendor.web.app/declined",
            client: "",
            expires: 1686818000,
            embedded_signing_enabled: 1,
            flexible_signing: 0,
            use_hidden_tags: 0,
            files: [
              {
                name: "House Waybill",
                file_url:
                  "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FCustomer%20Docs%2FHouse%20Waybill%20Final%205.4.2020.pdf?alt=media&token=02fedb99-548e-4f90-ab02-30fb0a071665",
                file_id: "",
                file_base64: "",
              },
            ],
            signers: [
              {
                id: 1,
                name: "Shipper Signer",
                email: this.state.orderData.origin.email,
                order: 1,
                // "pin": "3874",
                message: "This is my custom message to Shipper.",
                deliver_email: "",
                language: "en",
              },
              {
                id: 2,
                name: "Driver Signer",
                email: this.state.dropOffDriverData.email,
                order: 2,
                // "pin": "3874",
                message: "This is my custom message to Driver.",
                deliver_email: "",
                language: "en",
              },
              {
                id: 3,
                name: "Consignee Signer",
                email: this.state.orderData.destination.email,
                order: 3,
                // "pin": "3874",
                message: "This is my custom message to Consignee.",
                deliver_email: "",
                language: "en",
              },
            ],
            recipients: [
              {
                name: "Justin",
                email: "development@kordspace.com",
                language: "en",
              },
              {
                name: "Vendor",
                email: this.props.user
                  ? this.props.user.email
                  : "justin@pondata.com",
                language: "en",
              },
            ],
            meta: {
              some_key: "some_value",
              another_key: "another_value",
            },
            fields: [
              [
                {
                  type: "signature",
                  x: "520",
                  y: "930",
                  width: "120",
                  height: "35",
                  page: "1",
                  signer: "1",
                  name: "",
                  identifier: "unique_field_identifier_1",
                  required: 1,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "",
                  options: [],
                  group: "",
                },
                {
                  type: "signature",
                  x: "50",
                  y: "995",
                  width: "120",
                  height: "35",
                  page: "1",
                  signer: "2",
                  name: "",
                  identifier: "unique_field_identifier_2",
                  required: 1,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "",
                  options: [],
                  group: "",
                },
                {
                  type: "signature",
                  x: "600",
                  y: "1010",
                  width: "150",
                  height: "35",
                  page: "1",
                  signer: "3",
                  name: "",
                  identifier: "unique_field_identifier_3",
                  required: 1,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "150",
                  y: "213",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Origin Company Name",
                  identifier: "unique_field_identifier_4",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.businessName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "150",
                  y: "230",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Origin Address",
                  identifier: "unique_field_identifier_5",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.address,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "100",
                  y: "243",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Origin City",
                  identifier: "unique_field_identifier_6",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.city,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "275",
                  y: "243",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Origin State",
                  identifier: "unique_field_identifier_7",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.state,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "360",
                  y: "243",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Origin Zip",
                  identifier: "unique_field_identifier_8",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.zip,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "140",
                  y: "257",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Origin Contact Name",
                  identifier: "unique_field_identifier_9",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.origin.firstName +
                    " " +
                    this.state.orderData.origin.lastName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "360",
                  y: "257",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Origin Reference No.",
                  identifier: "unique_field_identifier_10",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.referenceID,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "90",
                  y: "272",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Origin Phone",
                  identifier: "unique_field_identifier_11",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.phone,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "290",
                  y: "272",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Origin Cell",
                  identifier: "unique_field_identifier_12",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.email,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "150",
                  y: "317",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Company Name",
                  identifier: "unique_field_identifier_13",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.businessName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "150",
                  y: "333",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Address",
                  identifier: "unique_field_identifier_14",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.address,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "100",
                  y: "348",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination City",
                  identifier: "unique_field_identifier_15",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.city,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "275",
                  y: "348",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination State",
                  identifier: "unique_field_identifier_16",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.state,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "360",
                  y: "348",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Zip",
                  identifier: "unique_field_identifier_17",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.zip,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "140",
                  y: "363",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Contact Name",
                  identifier: "unique_field_identifier_18",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.destination.firstName +
                    " " +
                    this.state.orderData.destination.lastName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "360",
                  y: "363",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Reference No.",
                  identifier: "unique_field_identifier_19",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.referenceID,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "90",
                  y: "377",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Phone",
                  identifier: "unique_field_identifier_20",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.phone,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "290",
                  y: "375",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Cell",
                  identifier: "unique_field_identifier_21",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.email,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "150",
                  y: "421",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Third Party Company Name",
                  identifier: "unique_field_identifier_22",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.thirdParty.businessName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "150",
                  y: "437",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Third Party Address",
                  identifier: "unique_field_identifier_23",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.thirdParty.address,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "100",
                  y: "452",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Third Party City",
                  identifier: "unique_field_identifier_24",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.thirdParty.city,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "275",
                  y: "452",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Third Party State",
                  identifier: "unique_field_identifier_25",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.thirdParty.state,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "360",
                  y: "452",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Third Party Zip",
                  identifier: "unique_field_identifier_26",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.thirdParty.zip,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "140",
                  y: "467",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Third Party Contact Name",
                  identifier: "unique_field_identifier_27",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.thirdParty.firstName +
                    " " +
                    this.state.orderData.thirdParty.lastName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "360",
                  y: "467",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Third Party Reference No.",
                  identifier: "unique_field_identifier_28",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.thirdParty.referenceID,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "90",
                  y: "481",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Third Party Phone",
                  identifier: "unique_field_identifier_29",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.thirdParty.phone,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "290",
                  y: "480",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Third Party Cell",
                  identifier: "unique_field_identifier_30",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.thirdParty.email,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "50",
                  y: "524",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Origin Special Instructions",
                  identifier: "unique_field_identifier_31",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.origin.customExtraService,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "50",
                  y: "545",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Destination Special Instructions",
                  identifier: "unique_field_identifier_32",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.destination.customExtraService,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "600",
                  y: "218",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Waybill Number",
                  identifier: "unique_field_identifier_33",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.airWaybillNumber,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "482",
                  y: "328",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Dispatcher Name",
                  identifier: "unique_field_identifier_34",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.dispatcherData.name,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "482",
                  y: "348",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Dispatcher Phone",
                  identifier: "unique_field_identifier_35",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.dispatcherData.cellPhone,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "482",
                  y: "368",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Dispatcher Email",
                  identifier: "unique_field_identifier_36",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.dispatcherData.email,
                  options: [],
                  group: "",
                },
                {
                  type: "checkbox",
                  x: "488",
                  y: "526",
                  width: "14",
                  height: "14",
                  page: "1",
                  signer: "1",
                  name: "Freight Charge Terms Prepaid",
                  identifier: "unique_field_identifier_37",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  value: this.state.orderData.billingParty == "Shipper" ? 1 : 0,
                  options: [],
                  group: "",
                },
                {
                  type: "checkbox",
                  x: "555",
                  y: "526",
                  width: "14",
                  height: "14",
                  page: "1",
                  signer: "1",
                  name: "Freight Charge Terms Collect",
                  identifier: "unique_field_identifier_38",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  value:
                    this.state.orderData.billingParty == "Consignee" ? 1 : 0,
                  options: [],
                  group: "",
                },
                {
                  type: "checkbox",
                  x: "630",
                  y: "526",
                  width: "14",
                  height: "14",
                  page: "1",
                  signer: "1",
                  name: "Freight Charge Terms 3rd Party",
                  identifier: "unique_field_identifier_39",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  value:
                    this.state.orderData.billingParty == "Third Party" ? 1 : 0,
                  options: [],
                  group: "",
                },
                {
                  type: "checkbox",
                  x: "445",
                  y: "553",
                  width: "14",
                  height: "14",
                  page: "1",
                  signer: "1",
                  name:
                    "Master bill of lading with attached underlying bills of lading.",
                  identifier: "unique_field_identifier_40",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  value: 0,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "50",
                  y: "630",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 1 Description",
                  identifier: "unique_field_identifier_41",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].description,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "385",
                  y: "630",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 1 Pieces",
                  identifier: "unique_field_identifier_42",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].quantity,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "455",
                  y: "630",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 1 Weight",
                  identifier: "unique_field_identifier_43",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].weight,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "505",
                  y: "630",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 1 Length",
                  identifier: "unique_field_identifier_44",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].length,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "540",
                  y: "630",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 1 Width",
                  identifier: "unique_field_identifier_45",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].width,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "580",
                  y: "630",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 1 Height",
                  identifier: "unique_field_identifier_46",
                  required: 1,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[0].height,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "620",
                  y: "630",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 1 Additional Shipper Information",
                  identifier: "unique_field_identifier_47",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value:
                    this.state.orderData.items[0].class +
                    " " +
                    this.state.orderData.items[0].unNumber +
                    " " +
                    this.state.orderData.items[0].properShippingName,
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "50",
                  y: "660",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 2 Description",
                  identifier: "unique_field_identifier_48",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].description
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "385",
                  y: "660",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 2 Pieces",
                  identifier: "unique_field_identifier_49",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].quantity
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "455",
                  y: "660",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 2 Weight",
                  identifier: "unique_field_identifier_50",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].weight
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "505",
                  y: "660",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 2 Length",
                  identifier: "unique_field_identifier_51",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].length
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "540",
                  y: "660",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 2 Width",
                  identifier: "unique_field_identifier_52",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].width
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "580",
                  y: "660",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 2 Height",
                  identifier: "unique_field_identifier_53",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].height
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "620",
                  y: "660",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Item 2 Additional Shipper Information",
                  identifier: "unique_field_identifier_54",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? this.state.orderData.items[1].class +
                      " " +
                      this.state.orderData.items[1].unNumber +
                      " " +
                      this.state.orderData.items[1].properShippingName
                    : " ",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "720",
                  y: "865",
                  width: "300",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "Total Declared Value",
                  identifier: "unique_field_identifier_55",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: this.state.orderData.items[1]
                    ? Number(this.state.orderData.items[0].declaredValue) +
                      Number(this.state.orderData.items[1].declaredValue)
                    : this.state.orderData.items[0].declaredValue,
                  options: [],
                  group: "",
                },
              ],
            ],
          },
          // "params": {
          //   "withFlightInfoOnly": "false"
          // }
        }).then(
          (response) => {
            console.log(response);
            this.setState({
              signingURL: response.data.signers[0].embedded_signing_url,
              signingURL1: response.data.signers[0].embedded_signing_url,
              signingURL2: response.data.signers[1].embedded_signing_url,
              signingURL3: response.data.signers[2].embedded_signing_url,
              signatureURLLoaded: true,
            });
            db.collection("TEST-orders")
              .doc(this.props.orderID)
              .set(
                {
                  dropOffRateConfirmHash: response.data.document_hash,
                },
                { merge: true }
              )
              .then(
                () => {
                  console.log(response);
                  // window.location.replace(this.state.signingURL)
                },
                (error) => {
                  console.log(error);
                }
              );
          },
          (error) => {
            console.log(error);
          }
        );
      })
      .then(async () => {
        //   console.log("resetting password")
        //  const email = this.state.authInfo.email
        // let subject = `Your CargoRx profile has been created!`
        // let html = `<p>Hello,</p>`
        // html += `Please reset yout password in the following email and sign in to the platform using the link below.`
        // html += `<a href="https://cargo-rx.web.app/pages/login-page">Sign In</a>`
        // const emails = [this.state.authInfo.email]
        // const attatchment = true;
        // const emailReturn = await sendEmail({
        //     emails,
        //     subject,
        //     html
        //   })
      })
      .then(() => {
        // window.location.reload()
      });
  };

  requestLTRSig = (signUrl) => {
    // this.setState({
    //   eSigModal: true
    // });

    db.collection("TEST-orders")
      .doc(this.props.orderID)
      .set(
        {
          signatureRequested: new Date(),
        },
        { merge: true }
      )
      .then(async () => {
        console.log("requesting signature");
        // console.log(this.state.authInfo.phone)
        //const email = this.props.user.email

        // let subject = `Your CargoRx profile has been created!`
        // let html = `<p>Hello,</p>`
        // html += `Please reset yout password in the following email and sign in to the platform using the link below.`
        // html += `<a href="https://cargo-rx.web.app/pages/login-page">Sign In</a>`
        // const emails = [this.state.authInfo.email]
        // const attatchment = true;

        // let body = 'Your CargoRx profile has been created!'
        // body += `Please reset yout password sign in to the platform using the link below.`
        // body += `https://cargo-rx.web.app/pages/login-page`
        // let from = '+17205139929'
        // let to = '+1' + this.state.authInfo.phone

        // let name = this.props.user.name
        // // let vendorIndex = this.state.vendorsData.indexOf(this.props.user.vendorID)
        // let vendor = this.state.vendorsData.filter(vendor => {
        //   return vendor.id === this.props.user.vendorID
        // })
        // // console.log(vendor)
        // let title = vendor.name + " Rate Confirmation for CargoRx Order #" + this.props.orderID
        // let subject = "CargoRx Rate Confirmation for " + vendor.name
        // let message = "Please review and sign your rate confirmation to be tendered your load."
        // let signers = [
        //     {
        //       email_address: this.props.user.email,
        //       name: this.props.user.name
        //     }
        // ]
        // let docURL = "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FAir%20Pick%20Up%20Rate%20Confirmation%20Final%203.3.2020.pdf?alt=media&token=e2206f0c-3117-4c95-a9e1-718aa813aee8"
        // console.log(name)
        // console.log(title)
        // console.log(subject)
        // console.log(message)
        // console.log(signers)
        // console.log(docURL)
        // const requestSignature = await signatureRequest({
        //   name, title, subject, message, signers, docURL
        // })

        const axios = require("axios");

        axios({
          method: "POST",
          url: `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252`,
          data: {
            sandbox: 1,
            is_draft: 0,
            embedded: 1,
            title: `LTR Document #${this.props.orderID}`,
            message: "This is my general document message.",
            use_signer_order: 1,
            reminders: 1,
            require_all_signers: 1,
            custom_requester_name: "",
            custom_requester_email: "",
            redirect: `https://cargo-rx-vendor.web.app/order/${
              this.props.orderID
            }?dropOffConfirmed=Y`,
            redirect_decline: "https://cargo-rx-vendor.web.app/declined",
            client: "",
            expires: 1686818000,
            embedded_signing_enabled: 1,
            flexible_signing: 0,
            use_hidden_tags: 0,
            files: [
              {
                name: "LTR BOL",
                file_url:
                  "https://firebasestorage.googleapis.com/v0/b/ltr-app.appspot.com/o/forms%2Fdoc51800820200624100032.pdf?alt=media&token=bdfd4a9c-8328-46a5-8ebe-445cf3df0ac8",
                file_id: "",
                file_base64: "",
              },
            ],
            signers: [
              {
                id: 1,
                name: "Vendor Signer",
                email: this.props.user
                  ? this.props.user.email
                  : "justin@pondata.com",
                order: 1,
                // "pin": "3874",
                message: "This is my custom message to Signer.",
                deliver_email: "",
                language: "en",
              },
            ],
            recipients: [
              {
                name: "Justin",
                email: "development@kordspace.com",
                language: "en",
              },
              {
                name: "Vendor",
                email: this.props.user
                  ? this.props.user.email
                  : "justin@pondata.com",
                language: "en",
              },
            ],
            meta: {
              some_key: "some_value",
              another_key: "another_value",
            },
            fields: [
              [
                {
                  type: "signature",
                  x: "250",
                  y: "560",
                  width: "120",
                  height: "35",
                  page: "1",
                  signer: "1",
                  name: "",
                  identifier: "unique_field_identifier_1",
                  required: 1,
                  readonly: 0,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "120",
                  y: "225",
                  width: "100",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Name",
                  identifier: "unique_field_identifier_6",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "Kevin Kersting",
                  options: [],
                  group: "",
                },
                {
                  type: "text",
                  x: "120",
                  y: "245",
                  width: "100",
                  height: "17",
                  page: "1",
                  signer: "1",
                  name: "CargoRx Contact Phone",
                  identifier: "unique_field_identifier_7",
                  required: 0,
                  readonly: 1,
                  validation_type: "",
                  text_size: "",
                  text_color: "",
                  text_font: "",
                  text_style: "",
                  value: "(303) 947-3066",
                  options: [],
                  group: "",
                },
              ],
            ],
          },
          // "params": {
          //   "withFlightInfoOnly": "false"
          // }
        }).then(
          (response) => {
            console.log(response);
            this.setState({
              signingURL: response.data.signers[0].embedded_signing_url,
              signatureURLLoaded: true,
            });
            db.collection("TEST-orders")
              .doc(this.props.orderID)
              .set(
                {
                  dropOffRateConfirmHash: response.data.document_hash,
                },
                { merge: true }
              )
              .then(
                () => {
                  console.log(response);
                  window.location.replace(this.state.signingURL);
                },
                (error) => {
                  console.log(error);
                }
              );
          },
          (error) => {
            console.log(error);
          }
        );
      })
      .then(async () => {
        //   console.log("resetting password")
        //  const email = this.state.authInfo.email
        // let subject = `Your CargoRx profile has been created!`
        // let html = `<p>Hello,</p>`
        // html += `Please reset yout password in the following email and sign in to the platform using the link below.`
        // html += `<a href="https://cargo-rx.web.app/pages/login-page">Sign In</a>`
        // const emails = [this.state.authInfo.email]
        // const attatchment = true;
        // const emailReturn = await sendEmail({
        //     emails,
        //     subject,
        //     html
        //   })
      })
      .then(() => {
        // window.location.reload()
      });
  };

  loadDrivers = () => {
    if (this.state.orderData.driverPickUpID) {
      let pickUpData = db
        .collection("TEST-users")
        .doc(this.state.orderData.driverPickUpID)
        .get()
        .then(
          (snapshot) => {
            var docData = snapshot.data();
            if (docData) {
              var docObj = {
                id: snapshot.id,
                ...docData,
              };
              return docObj;
            } else {
              return null;
            }
          },
          (error) => {
            console.log("error fetching data: ", error);
          }
        )
        .then((docObj) => {
          this.setState({
            pickUpDriverData: docObj,
            pickUpDriverDataLoaded: true,
          });
        });
    }
    if (this.state.orderData.driverDropOffID) {
      let dropOffData = db
        .collection("TEST-users")
        .doc(this.state.orderData.driverDropOffID)
        .get()
        .then(
          (snapshot) => {
            var docData = snapshot.data();
            if (docData) {
              var docObj = {
                id: snapshot.id,
                ...docData,
              };
              return docObj;
            } else {
              return null;
            }
          },
          (error) => {
            console.log("error fetching data: ", error);
          }
        )
        .then((docObj) => {
          this.setState({
            dropOffDriverData: docObj,
            dropOffDriverDataLoaded: true,
          });
        });
    }

    if (this.state.orderData.dispatcherID) {
      let dispatcherData = db
        .collection("TEST-users")
        .doc(this.state.orderData.dispatcherID)
        .get()
        .then(
          (snapshot) => {
            var docData = snapshot.data();
            if (docData) {
              var docObj = {
                id: snapshot.id,
                ...docData,
              };
              return docObj;
            } else {
              return null;
            }
          },
          (error) => {
            console.log("error fetching data: ", error);
          }
        )
        .then((docObj) => {
          this.setState({
            dispatcherData: docObj,
            dispatcherDataLoaded: true,
          });
        });
    }
  };

  loadVendors = () => {
    let pickUpData = db
      .collection("TEST-vendors")
      .doc(this.state.orderData.vendorPickUpID)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            var docObj = {
              id: snapshot.id,
              ...docData,
            };
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((docObj) => {
        this.setState({
          pickUpVendorData: docObj,
          pickUpVendorDataLoaded: true,
        });
      });

    if (
      this.state.orderData.deliveryType == "Air" ||
      this.state.orderData.deliveryType == "Scheduled Air"
    ) {
      let dropOffData = db
        .collection("TEST-vendors")
        .doc(this.state.orderData.vendorDropOffID)
        .get()
        .then(
          (snapshot) => {
            var docData = snapshot.data();
            if (docData) {
              var docObj = {
                id: snapshot.id,
                ...docData,
              };
              return docObj;
            } else {
              return null;
            }
          },
          (error) => {
            console.log("error fetching data: ", error);
          }
        )
        .then((docObj) => {
          this.setState({
            dropOffVendorData: docObj,
            dropOffVendorDataLoaded: true,
          });
        });
    }
  };

  updatePickUpRateConfirmStatus = () => {
    console.log("updating pick up rate status");
    db.collection("TEST-orders")
      .doc(this.props.orderID)
      .set(
        {
          pickUpRateStatus: "confirmed",
        },
        { merge: true }
      )
      .then(
        () => {
          // console.log();
          this.setState({
            pickUpRateStatus: "confirmed",
            pickUpConfirmedStatusUpdated: true,
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  updateDropOffRateConfirmStatus = () => {
    console.log("updating pick up rate status");
    db.collection("TEST-orders")
      .doc(this.props.orderID)
      .set(
        {
          dropOffRateStatus: "confirmed",
        },
        { merge: true }
      )
      .then(
        () => {
          // console.log();
          this.setState({
            dropOffRateStatus: "confirmed",
            dropOffConfirmedStatusUpdated: true,
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  loadAirportAddress = (airline, origin, destination) => {
    console.log(airline, origin, destination);
    const airlineAppend = airline + " Airlines";
    let data = db
      .collection("TEST-vendors")
      .where("name", "==", airlineAppend)
      .where("airCodes", "array-contains", origin)
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((data) => {
        data;
        this.setState({
          originAirlineDetails: data,
          airportAddressUpdated: true,
        });
      });

    let destinationData = db
      .collection("TEST-vendors")
      .where("name", "in", [airline, airline + " Airlines"])
      .where("airCodes", "array-contains", destination)
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((data) => {
        data;
        this.setState({
          destinationAirlineDetails: data,
          airportAddressUpdated: true,
        });
      });
  };

  render() {
    const { classes, modalClose, authUser, orderID, user } = this.props;
    function StyledRadio(props) {
      return (
        <Radio
          className={classes.root}
          disableRipple
          color="default"
          checkedIcon={
            <span className={clsx(classes.icon, classes.checkedIcon)} />
          }
          icon={<span className={classes.icon} />}
          {...props}
        />
      );
    }
    // Inspired by blueprintjs
    function StyledRadio(props) {
      return (
        <Radio
          className={classes.root}
          disableRipple
          color="default"
          checkedIcon={
            <span className={clsx(classes.icon, classes.checkedIcon)} />
          }
          icon={<span className={classes.icon} />}
          {...props}
        />
      );
    }
    radiusOptions;
    const shippingModes = ["", "LTL", "TL"];
    const role = ["", "Shipper", "Consignee", "Third Party"];
    const locationTypes = [
      "",
      "Business",
      "Construction Site",
      "Convention Center or Tradeshow",
      "Freight Carrier Terminal",
      "Home Based Business",
      "Mlitary Base",
      "Mini-Storage / Self Storage Facility",
      "Religious Institution",
      "Residential / Home",
    ];
    const packagingTypes = [
      "",
      'Pallets: Standard (40" x 48")',
      'Pallets (48" x 48")',
      'Pallets (60" x 48")',
      "Pallets (enter dimensions)",
      "Boxed",
      "Crated",
      "Drums or Barrels",
    ];
    const freightClass = [
      "",
      "I dont know",
      "50",
      "55",
      "60",
      "65",
      "70",
      "77.5",
      "85",
      "92.5",
      "100",
      "110",
      "125",
      "150",
      "175",
      "200",
      "250",
      "300",
      "400",
      "500",
    ];
    const radiusOptions = ["", "50", "100", "150", "200", "250", "300"];

    if (authUser && !this.state.userSet) {
      this.setUser(authUser.uid);
    }
    //console.log(authUser)
    // reset modal when closed
    // if (this.state.messageSent) { this.resetRequest() }

    let pathname = window.location.pathname;

    if (this.state.orderData) {
      console.log(
        (this.state.orderData.items[0]
          ? Number(this.state.orderData.items[0].declaredValue)
          : 0) +
          (this.state.orderData.items[1]
            ? Number(this.state.orderData.items[1].declaredValue)
            : 0) +
          (this.state.orderData.items[2]
            ? Number(this.state.orderData.items[2].declaredValue)
            : 0) +
          (this.state.orderData.items[3]
            ? Number(this.state.orderData.items[3].declaredValue)
            : 0)
      );
    }
    console.log(this.state);
    console.log(this.props);

    if (user.dataLoaded && !this.state.vendorsDataLoaded) {
      this.loadVendorsData();
    }

    if (user.dataLoaded && !this.state.orderDataLoaded) {
      this.loadOrdersData(this.props.orderID);
    }

    if (this.state.vendorPickUp && !this.state.driversPickUpDataLoaded) {
      this.loadDriversPickUpData(this.state.vendorPickUp.id);
    }

    if (this.state.vendorDropOff && !this.state.driversDropOffDataLoaded) {
      this.loadDriversDropOffData(this.state.vendorDropOff.id);
    }

    if (this.state.driverPickUp && !this.state.pickUpDriverContactLoaded) {
      this.loadPickUpDriverContact(this.state.driverPickUp.id);
    }

    if (this.state.orderData && this.state.orderData.flight) {
      this.getFlightAddress(this.state.orderData.flight.number);
      console.log("hello");
    }

    if (
      this.state.orderData &&
      !this.state.dropOffDriverDataLoaded &&
      !this.state.pickUpDriverDataLoaded &&
      !this.state.dispatcherDataLoaded
    ) {
      this.loadDrivers();
    }

    if (
      this.state.orderData &&
      !this.state.dropOffVendorDataLoaded &&
      !this.state.pickUpVendorDataLoaded
    ) {
      this.loadVendors();
    }
    // console.log(window.location.search)
    // console.log(window.location.search.includes("pickUpConfirmed=Y"))

    if (this.state.orderData) {
      if (
        window.location.search.includes("pickUpConfirmed=Y") &&
        this.state.orderData.pickUpRateStatus == "unconfirmed" &&
        !this.state.pickUpConfirmedStatusUpdated
      ) {
        this.updatePickUpRateConfirmStatus();
      }

      if (
        window.location.search.includes("dropOffConfirmed=Y") &&
        this.state.orderData.dropOffRateStatus == "unconfirmed" &&
        !this.state.dropOffConfirmedStatusUpdated
      ) {
        this.updateDropOffRateConfirmStatus();
      }
    }

    if (this.state.orderData && !this.state.airportAddressUpdated) {
      if (this.state.orderData.flight) {
        if (this.state.orderData.flight.originAirport) {
          this.loadAirportAddress(
            this.state.orderData.flight.airlineName,
            this.state.orderData.flight.originAirport,
            this.state.orderData.flight.destinationAirport
          );
        }
      }
    }

    // console.log(this.state);
    // console.log((((this.state.orderData.items[0] ? Number(this.state.orderData.items[0].declaredValue) : 0) + (this.state.orderData.items[1] ? Number(this.state.orderData.items[1].declaredValue) : 0) + (this.state.orderData.items[2] ? Number(this.state.orderData.items[2].declaredValue) : 0) + (this.state.orderData.items[3] ? Number(this.state.orderData.items[3].declaredValue) : 0))));
    let weight = 0;
    if (this.state.orderData) {
      let items = this.state.orderData.items;
      for (let i = 0; i < items.length; i++) {
        const wpp = parseInt(items[i].weight ? items[i].weight : 0);
        const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
        weight += wpp * qty;
      }
    }

    return (
      <div>
        {this.state.messageSent ? (
          <GridContainer justify="center">
            <GridItem xs={11}>
              <h4 className={classes.textPrimary}>Order Submitted!</h4>
            </GridItem>
          </GridContainer>
        ) : (
          <GridContainer style={{ marginTop: "-30px" }} justify="center">
            {/* {
                this.state.mapDataSaved ?
                  <GridItem xs={12} md={8}>
                    <ShipFullScreenMap originCoords={this.state.originCoords} destinationCoords={this.state.destinationCoords} />
                  </GridItem>
                  : null
              } */}
            <GridItem xs={12}>
              <div className={classes.formContainer}>
                <form onSubmit={this.handleSubmit}>
                  <GridContainer justify="center">
                    <GridItem xs={11}>
                      {this.state.messageError ? (
                        <h5 className={classes.bodyText}>
                          There Has Been An Error: {this.state.messageError}
                        </h5>
                      ) : null}
                      {this.state.step1 ? (
                        <div>
                          <h3 className={classes.bodyText}>Step 1 of 4</h3>
                          <p>
                            Tell us who you are and where you're coming from.
                          </p>
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              htmlFor="role"
                              className={classes.selectLabel}
                            >
                              YOUR ROLE:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={this.state.role}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: "role",
                                name: "role",
                              }}
                            >
                              {role.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                  }}
                                  value={item}
                                  key={item}
                                >
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {/*<FormControl
                          fullWidth
                          className={classes.selectFormControl}>
                          <InputLabel
                            htmlFor="shippingmode"
                            className={classes.selectLabel}>
                            SHIPPING MODE:
                  </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.shippingMode}
                            onChange={this.handleSelectChange}
                            inputProps={{
                              id: 'shippingMode',
                              name: 'shippingMode'
                            }}
                          >
                            {
                              shippingModes.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem
                                  }}
                                  value={item}
                                  key={item}
                                >{item}</MenuItem>
                              ))
                            }
                          </Select>
                          </FormControl>*/}

                          <br />
                          <br />
                          <h4 className={classes.bodyText}>
                            <b>Origin Details</b>
                          </h4>

                          <CustomInput
                            labelText="Business Name"
                            id="originBusinessName"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.originBusinessName
                                ? this.state.originBusinessName
                                : "",
                            }}
                          />

                          <CustomInput
                            labelText="Address"
                            id="originAddress"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.originAddress
                                ? this.state.originAddress
                                : "",
                            }}
                          />
                          <GridContainer justify="center">
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="City"
                                id="originCity"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originCity
                                    ? this.state.originCity
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem
                              xs={3}
                              style={{
                                padding: "0px, 0px, 0px, 0px !important",
                              }}
                            >
                              <CustomInput
                                labelText="State"
                                id="originState"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originState
                                    ? this.state.originState
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3}>
                              <CustomInput
                                labelText="ZIP"
                                id="originZip"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originZip
                                    ? this.state.originZip
                                    : "",
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12}>
                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                              >
                                <InputLabel
                                  htmlFor="originType"
                                  className={classes.selectLabel}
                                >
                                  LOCATION TYPE:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu,
                                  }}
                                  classes={{
                                    select: classes.select,
                                  }}
                                  value={this.state.originType}
                                  onChange={this.handleSelectChange}
                                  defaultValue={
                                    this.state.originZip
                                      ? this.state.originZip
                                      : ""
                                  }
                                  inputProps={{
                                    id: "originType",
                                    name: "originType",
                                  }}
                                >
                                  {locationTypes.map((item) => (
                                    <MenuItem
                                      classes={{
                                        root: classes.selectMenuItem,
                                      }}
                                      value={item}
                                      key={item}
                                    >
                                      {item}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </GridItem>
                          </GridContainer>
                          <GridContainer style={{ marginTop: "10px" }}>
                            <GridItem xs={6}>
                              <Datetime
                                selected={this.state.pickUpDate}
                                onChange={this.handlePickUpDateChange}
                                defaultValue={
                                  this.state.pickUpDate
                                    ? this.state.pickUpDate
                                    : ""
                                }
                                timeFormat={true}
                                isValidDate={this.valid}
                                renderInput={(dateInputProps, open, close) => (
                                  <CustomInput
                                    inputProps={{
                                      ...dateInputProps,
                                      id: "pickUpDate",
                                      name: "pickUpDate",
                                      required: true,
                                    }}
                                    onBlur={close}
                                    onFocus={open}
                                    labelText="Pickup Date"
                                    formControlProps={{
                                      fullWidth: true,
                                    }}
                                  />
                                )}
                              />
                            </GridItem>
                            <GridItem xs={6}>
                              <h5 className={classes.bodyText}>
                                EXTRA SERVICES
                              </h5>
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  " " +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleTogglePickupServices(
                                          "Lift Gate"
                                        )
                                      }
                                      checked={
                                        this.state.pickUpServices.indexOf(
                                          "Lift Gate"
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Lift Gate at Pickup Point"
                                />
                              </div>
                              <br />
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  " " +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleTogglePickupServices(
                                          "Limited Access"
                                        )
                                      }
                                      checked={
                                        this.state.pickUpServices.indexOf(
                                          "Limited Access"
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Limited Access Pick Up"
                                />
                              </div>
                            </GridItem>
                          </GridContainer>

                          <Button
                            style={{ float: "right", marginTop: "20px" }}
                            color="primary"
                            onClick={() => this.saveOrigin()}
                          >
                            NEXT
                          </Button>
                        </div>
                      ) : null}

                      {/* 
                        <CustomInput
                          labelText="Notes"
                          id="description"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            id: "pickUpNotes",
                            name: "pickUpNotes",
                            type: "text",
                            multiline: true,
                            rows: 5,
                            onChange: (event) => this.handleChange(event)
                          }}
                        /> */}

                      {this.state.step2 ? (
                        <div>
                          <h3 className={classes.bodyText}>Step 2 of 4</h3>
                          <p>Tell us where you're going.</p>

                          <h4 className={classes.bodyText}>
                            <b>Receiver Details</b>
                          </h4>

                          <CustomInput
                            labelText="Business Name"
                            id="destinationBusinessName"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.destinationBusinessName
                                ? this.state.destinationBusinessName
                                : "",
                            }}
                          />

                          <CustomInput
                            labelText="Address"
                            id="destinationAddress"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.destinationAddress
                                ? this.state.destinationAddress
                                : "",
                            }}
                          />
                          <GridContainer justify="center">
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="City"
                                id="destinationCity"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationCity
                                    ? this.state.destinationCity
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem
                              xs={3}
                              style={{
                                padding: "0px, 0px, 0px, 0px !important",
                              }}
                            >
                              <CustomInput
                                labelText="State"
                                id="destinationState"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationState
                                    ? this.state.destinationState
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3}>
                              <CustomInput
                                labelText="ZIP"
                                id="destinationZip"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationZip
                                    ? this.state.destinationZip
                                    : "",
                                }}
                              />
                            </GridItem>
                          </GridContainer>

                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              htmlFor="destinationType"
                              className={classes.selectLabel}
                            >
                              LOCATION TYPE:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={this.state.destinationType}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: "destinationType",
                                name: "destinationType",
                              }}
                            >
                              {locationTypes.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                  }}
                                  value={item}
                                  key={item}
                                >
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <GridContainer style={{ marginTop: "10px" }}>
                            <GridItem xs={6}>
                              <Datetime
                                selected={this.state.dropOffDate}
                                onChange={this.handleDropOffDateChange}
                                defaultValue={
                                  this.state.dropOffDate
                                    ? this.state.dropOffDate
                                    : ""
                                }
                                timeFormat={true}
                                isValidDate={this.valid}
                                renderInput={(dateInputProps, open, close) => (
                                  <CustomInput
                                    inputProps={{
                                      ...dateInputProps,
                                      id: "dropOffDate",
                                      name: "dropOffDate",
                                      required: true,
                                    }}
                                    onBlur={close}
                                    onFocus={open}
                                    labelText="Drop Off Date"
                                    formControlProps={{
                                      fullWidth: true,
                                    }}
                                  />
                                )}
                              />
                            </GridItem>
                            <GridItem xs={6}>
                              <h5 className={classes.bodyText}>
                                EXTRA SERVICES
                              </h5>
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  " " +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleToggleDropOffServices(
                                          "Lift Gate"
                                        )
                                      }
                                      checked={
                                        this.state.dropOffServices.indexOf(
                                          "Lift Gate"
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Lift Gate at Pickup Point"
                                />
                              </div>
                              <br />
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  " " +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleToggleDropOffServices(
                                          "Limited Access"
                                        )
                                      }
                                      checked={
                                        this.state.dropOffServices.indexOf(
                                          "Limited Access"
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Limited Access Pick Up"
                                />
                              </div>
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ marginTop: "20px" }}
                                onClick={() => this.step2Back()}
                              >
                                BACK
                              </Button>
                            </GridItem>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ float: "right", marginTop: "20px" }}
                                onClick={() => this.saveDestination()}
                              >
                                NEXT
                              </Button>
                            </GridItem>
                          </GridContainer>
                        </div>
                      ) : null}

                      {/* <CustomInput
                              labelText="Notes"
                              id="dropOffNotes"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                type: "text",
                                multiline: true,
                                rows: 5,
                                onChange: (event) => this.handleChange(event)
                              }}
                            /> */}
                      {this.state.step3 ? (
                        <div>
                          <h3 className={classes.bodyText}>Step 3 of 4</h3>
                          <p>Tell us who we'll be dealing with and when.</p>
                          <p>
                            <b>Who can we contact at the origin address?</b>
                          </p>
                          <GridContainer>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Name"
                                id="originContactName"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originContactName
                                    ? this.state.originContactName
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Email"
                                id="originContactEmail"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originContactEmail
                                    ? this.state.originContactEmail
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Phone"
                                id="originContactPhone"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originContactPhone
                                    ? this.state.originContactPhone
                                    : "",
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <p>
                            <b>What are their business hours?</b>
                          </p>
                          <GridContainer>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Open"
                                id="originOpenTime"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originOpenTime
                                    ? this.state.originOpenTime
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={2}>
                              <p>to</p>
                            </GridItem>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Close"
                                id="originCloseTime"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originCloseTime
                                    ? this.state.originCloseTime
                                    : "",
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <p>
                            <b>When should we pick up the freight?</b>
                          </p>
                          <GridContainer>
                            <GridItem xs={2}>
                              <p>Between</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="Start"
                                id="originStartTimeWindow"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originStartTimeWindow
                                    ? this.state.originStartTimeWindow
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={1}>
                              <p>and</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="End"
                                id="originEndTimeWindow"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originEndTimeWindow
                                    ? this.state.originEndTimeWindow
                                    : "",
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <br /> <br />
                          <p>
                            <b>
                              Who can we contact at the destination address?
                            </b>
                          </p>
                          <GridContainer>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Name"
                                id="destinationContactName"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state
                                    .destinationContactName
                                    ? this.state.destinationContactName
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Email"
                                id="destinationContactEmail"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state
                                    .destinationContactEmail
                                    ? this.state.destinationContactEmail
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Phone"
                                id="destinationContactPhone"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state
                                    .destinationContactPhone
                                    ? this.state.destinationContactPhone
                                    : "",
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <p>
                            <b>What are their business hours?</b>
                          </p>
                          <GridContainer>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Open"
                                id="destinationOpenTime"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationOpenTime
                                    ? this.state.destinationOpenTime
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={2}>
                              <p>to</p>
                            </GridItem>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Close"
                                id="destinationCloseTime"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationCloseTime
                                    ? this.state.destinationCloseTime
                                    : "",
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <p>
                            <b>When should we drop off the freight?</b>
                          </p>
                          <GridContainer>
                            <GridItem xs={2}>
                              <p>Between</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="Start"
                                id="destinationStartTimeWindow"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state
                                    .destinationStartTimeWindow
                                    ? this.state.destinationStartTimeWindow
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={1}>
                              <p>and</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="End"
                                id="destinationEndTimeWindow"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state
                                    .destinationEndTimeWindow
                                    ? this.state.destinationEndTimeWindow
                                    : "",
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ marginTop: "20px" }}
                                onClick={() => this.step3Back()}
                              >
                                BACK
                              </Button>
                            </GridItem>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ float: "right", marginTop: "20px" }}
                                onClick={() => this.saveFreight()}
                              >
                                NEXT
                              </Button>
                            </GridItem>
                          </GridContainer>
                        </div>
                      ) : null}
                      {this.state.step4 ? (
                        <div>
                          <h3 className={classes.bodyText}>Step 4 of 4</h3>
                          <p>Tell us what you are shipping.</p>

                          <h3 className={classes.bodyText}>ITEM #1</h3>
                          <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                          <div
                            className={
                              classes.checkboxAndRadio +
                              " " +
                              classes.checkboxAndRadioHorizontal
                            }
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  tabIndex={-1}
                                  onClick={() =>
                                    this.handleToggleServices("Hazmat")
                                  }
                                  checked={
                                    this.state.services.indexOf("Hazmat") !== -1
                                      ? true
                                      : false
                                  }
                                  checkedIcon={
                                    <Check className={classes.checkedIcon} />
                                  }
                                  icon={
                                    <Check className={classes.uncheckedIcon} />
                                  }
                                  color="primary"
                                  classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot,
                                  }}
                                />
                              }
                              classes={{ label: classes.bodyText }}
                              label="Hazmat"
                            />
                          </div>
                          <div
                            className={
                              classes.checkboxAndRadio +
                              " " +
                              classes.checkboxAndRadioHorizontal
                            }
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  tabIndex={-1}
                                  onClick={() =>
                                    this.handleToggleServices("Over Length")
                                  }
                                  checked={
                                    this.state.services.indexOf(
                                      "Over Length"
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                  checkedIcon={
                                    <Check className={classes.checkedIcon} />
                                  }
                                  icon={
                                    <Check className={classes.uncheckedIcon} />
                                  }
                                  color="primary"
                                  classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot,
                                  }}
                                />
                              }
                              classes={{ label: classes.bodyText }}
                              label="Over Length"
                            />
                          </div>
                          <GridContainer>
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="UN Number"
                                id="unNumber"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.unNumber
                                    ? this.state.unNumber
                                    : "",
                                }}
                              />
                            </GridItem>
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="Proper Shipping Name"
                                id="properShippingName"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.properShippingName
                                    ? this.state.properShippingName
                                    : "",
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              htmlFor="packaging"
                              className={classes.selectLabel}
                            >
                              PACKAGING:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={this.state.packaging}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: "packaging",
                                name: "packaging",
                              }}
                            >
                              {packagingTypes.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                  }}
                                  value={item}
                                  key={item}
                                >
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <CustomInput
                            labelText="Qty"
                            id="quantity"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: "number",
                              min: "0",
                              step: "1",
                              onChange: (event) => this.handleChange(event),
                            }}
                          />
                          <CustomInput
                            labelText="Total Weight"
                            id="weight"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: "number",
                              min: "0",
                              step: "1",
                              onChange: (event) => this.handleChange(event),
                            }}
                          />
                          {this.state.packaging ==
                          "Pallets (enter dimensions)" ? (
                            <GridContainer>
                              <GridItem xs={3}>
                                <CustomInput
                                  labelText="Height"
                                  id="height"
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                  inputProps={{
                                    required: true,
                                    type: "number",
                                    min: "0",
                                    step: "1",
                                    onChange: (event) =>
                                      this.handleChange(event),
                                    defaultValue: this.state.height
                                      ? this.state.height
                                      : "",
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4}>
                                <CustomInput
                                  labelText="Width"
                                  id="width"
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                  inputProps={{
                                    required: true,
                                    type: "number",
                                    min: "0",
                                    step: "1",
                                    onChange: (event) =>
                                      this.handleChange(event),
                                    defaultValue: this.state.width
                                      ? this.state.width
                                      : "",
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={3}>
                                <CustomInput
                                  labelText="Depth"
                                  id="depth"
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                  inputProps={{
                                    required: true,
                                    type: "number",
                                    min: "0",
                                    step: "1",
                                    onChange: (event) =>
                                      this.handleChange(event),
                                    defaultValue: this.state.depth
                                      ? this.state.depth
                                      : "",
                                  }}
                                />
                              </GridItem>
                            </GridContainer>
                          ) : null}

                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              htmlFor="class"
                              className={classes.selectLabel}
                            >
                              FREIGHT CLASS:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={this.state.class}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: "class",
                                name: "class",
                              }}
                            >
                              {freightClass.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                  }}
                                  value={item}
                                  key={item}
                                >
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {!this.state.item2 ? (
                            <Button
                              color="primary"
                              onClick={() => this.addItem()}
                            >
                              ADD ITEM
                            </Button>
                          ) : null}
                          {this.state.item2 ? (
                            <div>
                              <h3 className={classes.bodyText}>ITEM #2</h3>
                              <h5 className={classes.bodyText}>
                                EXTRA SERVICES
                              </h5>
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  " " +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleToggleServices("Hazmat")
                                      }
                                      checked={
                                        this.state.services.indexOf(
                                          "Hazmat"
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Hazmat"
                                />
                              </div>
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  " " +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleToggleServices("Over Length")
                                      }
                                      checked={
                                        this.state.services.indexOf(
                                          "Over Length"
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Over Length"
                                />
                              </div>
                              <GridContainer>
                                <GridItem xs={6}>
                                  <CustomInput
                                    labelText="UN Number"
                                    id="unNumber"
                                    formControlProps={{
                                      fullWidth: true,
                                    }}
                                    inputProps={{
                                      required: true,
                                      type: "number",
                                      min: "0",
                                      step: "1",
                                      onChange: (event) =>
                                        this.handleChange(event),
                                    }}
                                  />
                                </GridItem>
                                <GridItem xs={6}>
                                  <CustomInput
                                    labelText="Proper Shipping Name"
                                    id="propperShippingName"
                                    formControlProps={{
                                      fullWidth: true,
                                    }}
                                    inputProps={{
                                      required: true,
                                      type: "text",
                                      onChange: (event) =>
                                        this.handleChange(event),
                                    }}
                                  />
                                </GridItem>
                              </GridContainer>
                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                              >
                                <InputLabel
                                  htmlFor="packaging"
                                  className={classes.selectLabel}
                                >
                                  PACKAGING:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu,
                                  }}
                                  classes={{
                                    select: classes.select,
                                  }}
                                  value={this.state.packaging}
                                  onChange={this.handleSelectChange}
                                  inputProps={{
                                    id: "packaging",
                                    name: "packaging",
                                  }}
                                >
                                  {packagingTypes.map((item) => (
                                    <MenuItem
                                      classes={{
                                        root: classes.selectMenuItem,
                                      }}
                                      value={item}
                                      key={item}
                                    >
                                      {item}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>

                              <CustomInput
                                labelText="Qty"
                                id="quantity"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "number",
                                  min: "0",
                                  step: "1",
                                  onChange: (event) => this.handleChange(event),
                                }}
                              />
                              <CustomInput
                                labelText="Total Weight"
                                id="weight"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: "number",
                                  min: "0",
                                  step: "1",
                                  onChange: (event) => this.handleChange(event),
                                }}
                              />
                              {this.state.packaging ==
                              "Pallets (enter dimensions)" ? (
                                <GridContainer>
                                  <GridItem xs={3}>
                                    <CustomInput
                                      labelText="Height"
                                      id="height"
                                      formControlProps={{
                                        fullWidth: true,
                                      }}
                                      inputProps={{
                                        required: true,
                                        type: "number",
                                        min: "0",
                                        step: "1",
                                        onChange: (event) =>
                                          this.handleChange(event),
                                      }}
                                    />
                                  </GridItem>
                                  <GridItem xs={4}>
                                    <CustomInput
                                      labelText="Width"
                                      id="width"
                                      formControlProps={{
                                        fullWidth: true,
                                      }}
                                      inputProps={{
                                        required: true,
                                        type: "number",
                                        min: "0",
                                        step: "1",
                                        onChange: (event) =>
                                          this.handleChange(event),
                                      }}
                                    />
                                  </GridItem>
                                  <GridItem xs={3}>
                                    <CustomInput
                                      labelText="Depth"
                                      id="depth"
                                      formControlProps={{
                                        fullWidth: true,
                                      }}
                                      inputProps={{
                                        required: true,
                                        type: "number",
                                        min: "0",
                                        step: "1",
                                        onChange: (event) =>
                                          this.handleChange(event),
                                      }}
                                    />
                                  </GridItem>
                                </GridContainer>
                              ) : null}

                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                              >
                                <InputLabel
                                  htmlFor="class"
                                  className={classes.selectLabel}
                                >
                                  FREIGHT CLASS:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu,
                                  }}
                                  classes={{
                                    select: classes.select,
                                  }}
                                  value={this.state.class}
                                  onChange={this.handleSelectChange}
                                  inputProps={{
                                    id: "class",
                                    name: "class",
                                  }}
                                >
                                  {freightClass.map((item) => (
                                    <MenuItem
                                      classes={{
                                        root: classes.selectMenuItem,
                                      }}
                                      value={item}
                                      key={item}
                                    >
                                      {item}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}

                          {this.state.flights &&
                            this.state.flights.map((flight) => {
                              if (flight.Stops.length == 0) {
                                return (
                                  <div>
                                    <Card
                                      style={{
                                        backgroundColor: "white",
                                        boxShadow: "0px 0px 5px 0px #888888",
                                      }}
                                    >
                                      {/* <CardHeader>
                          <h5 style={{ color: "black" }}> <i>Case #{flight.id}</i> <br /></h5>
                        </CardHeader> */}
                                      <CardBody>
                                        <p>
                                          <span style={{ color: "black" }}>
                                            Carrier:
                                          </span>{" "}
                                          <span
                                            style={{
                                              fontWeight: "900",
                                              color: "black",
                                            }}
                                          >
                                            {flight.Carriers}
                                          </span>{" "}
                                        </p>
                                        {/*<p><span style={{ color: "black" }}>Stops:</span> <span style={{ fontWeight: "900", color: "black" }}>{flight.Stops.length}</span> </p>
                          <p>Flights: {flight.FlightNumbers.map(flight => {
                            return (
                              <p>
                                {flight.FlightNumber} <br />{flight.CarrierId}
                              </p>
                            )
                          })}</p>*/}
                                        <GridContainer>
                                          <GridItem xs={6}>
                                            {String(flight.Departure)}
                                          </GridItem>
                                          <GridItem xs={6}>
                                            {String(flight.Arrival)}
                                          </GridItem>
                                        </GridContainer>
                                      </CardBody>
                                    </Card>
                                  </div>
                                );
                              } else {
                                null;
                              }
                            })}
                          {this.state.assigningAction ? (
                            <div>
                              <p className={classes.bodyText}>
                                {this.state.assigningAction}
                              </p>
                            </div>
                          ) : (
                            <div>
                              <GridContainer>
                                <GridItem xs={6}>
                                  <Button
                                    color="primary"
                                    style={{ marginTop: "20px" }}
                                    onClick={() => this.step4Back()}
                                  >
                                    BACK
                                  </Button>
                                </GridItem>
                                <GridItem xs={6}>
                                  <Button
                                    color="primary"
                                    style={{
                                      float: "right",
                                      marginTop: "20px",
                                    }}
                                    onClick={() =>
                                      this.getFlights(
                                        this.state.originCoords,
                                        this.state.destinationCoords
                                      )
                                    }
                                  >
                                    NEXT
                                  </Button>
                                </GridItem>
                              </GridContainer>
                            </div>
                          )}
                        </div>
                      ) : null}
                      {this.state.step5 ? (
                        <React.Fragment>
                          <br />
                          <GridContainer>
                            <GridItem xs={12}>
                              {this.state.orderData && (
                                <ShipFullScreenMap
                                  originCoords={{
                                    lat: this.state.orderData.originLat,
                                    lng: this.state.orderData.originLng,
                                  }}
                                  destinationCoords={{
                                    lat: this.state.orderData.destinationLat,
                                    lng: this.state.orderData.destinationLng,
                                  }}
                                  driverCoords={
                                    this.state.orderData.dropOffDriverLocation
                                  }
                                />
                              )}
                            </GridItem>
                          </GridContainer>
                          <h4>
                            <b>
                              Summary Order #
                              {this.state.orderData
                                ? this.state.orderData.freightBillNumber
                                : null}
                            </b>
                          </h4>
                          <GridContainer>
                            <br />
                            <br />
                            {this.state.orderData && (
                              <GridItem xs={12}>
                                Mode:{" "}
                                {this.state.orderData.deliveryType == "Air"
                                  ? "Next Flight Out"
                                  : this.state.orderData.deliveryType ==
                                    "Scheduled Air"
                                    ? "Next Day Air"
                                    : this.state.orderData.deliveryType ==
                                      "Ground"
                                      ? "Dedicated Ground"
                                      : this.state.orderData.deliveryType ==
                                        "Additional Options"
                                        ? "Additional Options"
                                        : "?"}
                                
                              </GridItem>
                              
                            )}
                             {this.state.orderData && (
                              <GridItem xs={12}>
                                Status:{" "}
                                {this.state.orderData.status}
                                <br />
                                <br />
                              </GridItem>
                              
                            )}

                            <GridItem xs={12} md={6}>
                              <p>
                                <b>Freight Information</b>
                              </p>
                              <p><b>Total Weight: {weight}</b></p>

                              <GridContainer>
                                {this.state.orderData &&
                                  this.state.orderData.items.map((item, i) => {
                                    return (
                                      <GridItem xs={12}>
                                        <GridItem xs={12}>
                                          <p>
                                            <b>Item # {i + 1}</b>
                                          </p>
                                        </GridItem>
                                        {item["isHazmat"] ? (
                                          <GridItem xs={12}>
                                            <GridContainer>
                                              <GridItem xs={4}>
                                                <p>
                                                  UN Number: {item.unNumber}
                                                </p>
                                              </GridItem>
                                              <GridItem xs={4}>
                                                <p>
                                                  Proper Shipping Name:{" "}
                                                  {item.properShippingName}
                                                </p>
                                              </GridItem>
                                              <GridItem xs={4}>
                                                <p>
                                                  Emergency Response Number:{" "}
                                                  {item.emergencyResponseNumber}
                                                </p>
                                              </GridItem>
                                            </GridContainer>
                                          </GridItem>
                                        ) : null}

                                        <GridContainer>
                                          <GridItem xs={4}>
                                            <p>Packaging: {item.packaging}</p>
                                          </GridItem>
                                          <GridItem xs={4}>
                                            <p>Quantity: {item.quantity}</p>
                                          </GridItem>
                                          <GridItem xs={4}>
                                            <p>Weight: {item.weight}</p>
                                          </GridItem>
                                          <GridItem xs={4}>
                                            <p>Height: {item.height}</p>
                                          </GridItem>
                                          <GridItem xs={4}>
                                            <p>Width: {item.width}</p>
                                          </GridItem>
                                          <GridItem xs={4}>
                                            <p>Length: {item.length}</p>
                                          </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                          {item.files &&
                                            item.files.map((file, i) => {
                                              return (
                                                <GridItem xs={4}>
                                                  <img
                                                    src={file.picURL}
                                                    width="100px"
                                                  />
                                                </GridItem>
                                              );
                                            })}
                                        </GridContainer>
                                        {item["isBrokenDown"] ? (
                                          <GridContainer>
                                            <GridItem xs={4}>
                                              Description: {item.description}
                                            </GridItem>
                                            <GridItem xs={4}>
                                              <p>Item can be broken down</p>
                                            </GridItem>
                                          </GridContainer>
                                        ) : (
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              Description: {item.description}
                                            </GridItem>
                                          </GridContainer>
                                        )}
                                        {item["class"] ? (
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              <p>
                                                Freight Class: {item["class"]}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                        ) : null}
                                        <br />
                                      </GridItem>
                                    );
                                  })}
                              </GridContainer>
                            </GridItem>
                            <GridItem xs={12} md={6}>
                              <GridContainer>
                                {this.state.orderData &&
                                  (this.props.user.superAdmin ||
                                    this.props.user.vendorID ==
                                      this.state.orderData.vendorPickUpID) && (
                                    <React.Fragment>
                                      <GridItem>
                                        <h4>
                                          <b>Pick Up</b>
                                        </h4>
                                      </GridItem>
                                      {this.state.orderData.deliveryType ==
                                        "Air" && (
                                        <GridItem xs={12}>
                                          <GridContainer>
                                            <GridItem>
                                              <b>
                                                <p>Pick Up</p>
                                              </b>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Driver:{" "}
                                                {
                                                  this.state.orderData
                                                    .driverPickUpName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Business:{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .businessName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .address
                                                }{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .city
                                                }{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .state
                                                }{" "}
                                                -{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .zip
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Date:{" "}
                                                {moment(
                                                  this.state.orderData.origin.date.toDate()
                                                ).format(
                                                  "MM-DD-YYYY HH:mm"
                                                )}{" "}
                                                {this.state.orderData.origin[
                                                  "startTimeWindow"
                                                ] &&
                                                  this.state.orderData.origin[
                                                    "startTimeWindow"
                                                  ] + " - "}{" "}
                                                {this.state.orderData.origin[
                                                  "endTimeWindow"
                                                ] &&
                                                  this.state.orderData.origin[
                                                    "endTimeWindow"
                                                  ]}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              <b>
                                                <p>Drop Off</p>
                                              </b>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Business:{" "}
                                                {this.state.orderData.flight &&
                                                  this.state.orderData.flight
                                                    .airlineName}{" "}
                                                {this.state.orderData.flight &&
                                                  this.state.orderData.flight
                                                    .originAirport}
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {this.state.orderData
                                                  .originAirlineDetails &&
                                                  this.state.orderData
                                                    .originAirlineDetails[0] &&
                                                  `${
                                                    this.state.orderData
                                                      .originAirlineDetails[0]
                                                      .physicalAddress
                                                  } ${
                                                    this.state.orderData
                                                      .originAirlineDetails[0]
                                                      .physicalCity
                                                  }, ${
                                                    this.state.orderData
                                                      .originAirlineDetails[0]
                                                      .physicalState
                                                  } - ${
                                                    this.state.orderData
                                                      .originAirlineDetails[0]
                                                      .physicalZip
                                                  }`}
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Date:{" "}
                                                {moment(
                                                  this.state.orderData.origin.date.toDate()
                                                ).format("MM-DD-YYYY")}{" "}
                                                {moment(
                                                  this.state.orderData.origin.deliverBy.toDate()
                                                ).format("HH:mm")}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                        </GridItem>
                                      )}
                                      {this.state.orderData.deliveryType ==
                                        "Scheduled Air" && (
                                        <GridItem xs={12}>
                                          <GridContainer>
                                            <GridItem>
                                              <b>
                                                <p>Pick Up</p>
                                              </b>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Driver:{" "}
                                                {
                                                  this.state.orderData
                                                    .driverPickUpName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Business:{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .businessName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .address
                                                }{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .city
                                                }{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .state
                                                }{" "}
                                                -{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .zip
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Date:{" "}
                                                {moment(
                                                  this.state.orderData.origin.date.toDate()
                                                ).format(
                                                  "MM-DD-YYYY HH:mm"
                                                )}{" "}
                                                {this.state.orderData.origin[
                                                  "startTimeWindow"
                                                ] &&
                                                  this.state.orderData.origin[
                                                    "startTimeWindow"
                                                  ] + " - "}{" "}
                                                {this.state.orderData.origin[
                                                  "endTimeWindow"
                                                ] &&
                                                  this.state.orderData.origin[
                                                    "endTimeWindow"
                                                  ]}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              <b>
                                                <p>Drop Off</p>
                                              </b>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Business:{" "}
                                                {
                                                  this.state.orderData
                                                    .originAirCarrier
                                                    .businessName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {
                                                  this.state.orderData
                                                    .originAirCarrier.address
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .originAirCarrier.city
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .originAirCarrier.state
                                                }{" "}
                                                -{" "}
                                                {
                                                  this.state.orderData
                                                    .originAirCarrier.zip
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Date:{" "}
                                                {moment(
                                                  this.state.orderData.origin.deliverBy.toDate()
                                                ).format("MM-DD-YYYY HH:mm")}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                        </GridItem>
                                      )}
                                      {(this.state.orderData.deliveryType ==
                                        "Ground" ||
                                        this.state.orderData.deliveryType ==
                                          "Additional Options") && (
                                        <GridItem xs={12}>
                                          <GridContainer>
                                            <GridItem>
                                              <b>
                                                <p>Pick Up</p>
                                              </b>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Driver:{" "}
                                                {
                                                  this.state.orderData
                                                    .driverPickUpName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Business:{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .businessName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .address
                                                }{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .city
                                                }{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .state
                                                }{" "}
                                                -{" "}
                                                {
                                                  this.state.orderData.origin
                                                    .zip
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Date:{" "}
                                                {moment(
                                                  this.state.orderData.origin.date.toDate()
                                                ).format(
                                                  "MM-DD-YYYY HH:mm"
                                                )}{" "}
                                                {this.state.orderData.origin[
                                                  "startTimeWindow"
                                                ] &&
                                                  this.state.orderData.origin[
                                                    "startTimeWindow"
                                                  ] + " - "}{" "}
                                                {this.state.orderData.origin[
                                                  "endTimeWindow"
                                                ] &&
                                                  this.state.orderData.origin[
                                                    "endTimeWindow"
                                                  ]}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              <b>
                                                <p>Drop Off</p>
                                              </b>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Business:{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.businessName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.address
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.city
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.state
                                                }{" "}
                                                -{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.zip
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Date:{" "}
                                                {moment(
                                                  this.state.orderData.serviceETA.toDate()
                                                ).format("MM-DD-YYYY HH:mm")}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                        </GridItem>
                                      )}
                                    </React.Fragment>
                                  )}
                                <br />
                                {this.state.orderData &&
                                  (this.props.user.superAdmin ||
                                    this.props.user.vendorID ==
                                      this.state.orderData.vendorDropOffID) && (
                                    <React.Fragment>
                                      <GridItem>
                                        <h4>
                                          <b>Drop Off</b>
                                        </h4>
                                      </GridItem>
                                      {this.state.orderData.deliveryType ==
                                        "Air" && (
                                        <GridItem xs={12}>
                                          <GridItem>
                                            <b>
                                              <p>Pick Up</p>
                                            </b>
                                          </GridItem>
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              <p>
                                                Driver:{" "}
                                                {
                                                  this.state.orderData
                                                    .driverDropOffName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Business:{" "}
                                                {this.state.orderData
                                                  .destinationAirlineDetails &&
                                                  this.state.orderData
                                                    .destinationAirlineDetails[0]
                                                    .name +
                                                    " " +
                                                    this.state.orderData
                                                      .destinationAirlineDetails[0]
                                                      .airCodes[0]}
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {this.state.orderData
                                                  .destinationAirlineDetails &&
                                                  this.state.orderData
                                                    .destinationAirlineDetails[0] &&
                                                  `${
                                                    this.state.orderData
                                                      .destinationAirlineDetails[0]
                                                      .physicalAddress
                                                  } ${
                                                    this.state.orderData
                                                      .destinationAirlineDetails[0]
                                                      .physicalCity
                                                  }, ${
                                                    this.state.orderData
                                                      .destinationAirlineDetails[0]
                                                      .physicalState
                                                  } - ${
                                                    this.state.orderData
                                                      .destinationAirlineDetails[0]
                                                      .physicalZip
                                                  }`}
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Date:{" "}
                                                {moment(
                                                  this.state.orderData.destination.deliverBy.toDate()
                                                ).format("MM-DD-YYYY HH:mm")}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              <b>
                                                <p>Drop Off</p>
                                              </b>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Business:{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.businessName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.address
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.city
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.state
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.zip
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Date:{" "}
                                                {this.state.orderData.air &&
                                                  moment(
                                                    this.state.orderData.air.quoteETA.toDate()
                                                  ).format("MM-DD-YYYY HH:mm")}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                        </GridItem>
                                      )}
                                      {this.state.orderData.deliveryType ==
                                        "Scheduled Air" && (
                                        <GridItem xs={12}>
                                            <b>
                                              <p>Pick Up</p>
                                            </b>
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              <p>
                                                Driver:{" "}
                                                {
                                                  this.state.orderData
                                                    .driverDropOffName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Business:{" "}
                                                {
                                                  this.state.orderData
                                                    .destinationAirCarrier
                                                    .businessName
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destinationAirCarrier
                                                    .airCode
                                                }
                                              </p>
                                            </GridItem>
                                            {/* <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {this.state.orderData
                                                  .destinationAirCarrier &&
                                                  this.state.orderData
                                                    .destinationAirCarrier[0] &&
                                                  `${
                                                    this.state.orderData
                                                      .destinationAirCarrier[0]
                                                      .physicalAddress
                                                  } ${
                                                    this.state.orderData
                                                      .destinationAirCarrier[0]
                                                      .physicalCity
                                                  }, ${
                                                    this.state.orderData
                                                      .destinationAirCarrier[0]
                                                      .physicalState
                                                  } - ${
                                                    this.state.orderData
                                                      .destinationAirCarrier[0]
                                                      .physicalZip
                                                  }`}
                                              </p>
                                            </GridItem> */}
                                            <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {
                                                  this.state.orderData
                                                    .destinationAirCarrier.address
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destinationAirCarrier.city
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destinationAirCarrier.state
                                                }{" "}
                                                -{" "}
                                                {
                                                  this.state.orderData
                                                    .destinationAirCarrier.zip
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Date:{" "}
                                                {moment(
                                                  this.state.orderData.destination.deliverBy.toDate()
                                                ).format("MM-DD-YYYY HH:mm")}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              <b>
                                                <p>Drop Off</p>
                                              </b>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Business:{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.businessName
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Address:{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.address
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.city
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.state
                                                }{" "}
                                                {
                                                  this.state.orderData
                                                    .destination.zip
                                                }
                                              </p>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <p>
                                                Date:{" "}
                                                {this.state.orderData
                                                  .cargoAir &&
                                                  moment(
                                                    this.state.orderData.cargoAir.quoteETA.toDate()
                                                  ).format("MM-DD-YYYY HH:mm")}
                                              </p>
                                            </GridItem>
                                          </GridContainer>
                                        </GridItem>
                                      )}
                                    </React.Fragment>
                                  )}
                                <GridItem xs={12}>
                                  <p style={{ marginTop: "10px" }}>
                                    <b>Rate Confirmation:</b>
                                  </p>
                                  {this.state.orderData && (
                                    <GridContainer>
                                      {(this.props.user.superAdmin ||
                                        this.props.user.vendorID ==
                                          this.state.orderData
                                            .vendorPickUpID) && (
                                        <GridItem xs={12} md={6}>
                                          Pick Up Rate for Vendor{" "}
                                          {this.state.orderData &&
                                            this.state.orderData
                                              .vendorPickUpName}
                                          <br />
                                          Rate: $
                                          {this.state.orderData &&
                                            this.state.orderData.pickUpRate}
                                          <br />
                                          Status:{" "}
                                          <span
                                            style={{
                                              color: this.state.orderData
                                                .pickUpRateConIsSigned
                                                ? "green"
                                                : "red",
                                            }}
                                          >
                                            {this.state.orderData
                                              .pickUpRateConIsSigned
                                              ? "confirmed"
                                              : "unconfirmed"}
                                          </span>
                                          {/* <span style={{ color: (this.state.orderData && (this.state.orderData.pickUpRateStatus == "unconfirmed" ? (this.state.pickUpRateStatus == "confirmed" ? "green" : "red") : "green")) }}>{this.state.pickUpRateStatus && this.state.pickUpRateStatus} {(this.state.orderData && !this.state.pickUpRateStatus) && this.state.orderData.pickUpRateStatus}</span><br /> */}
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <div>
                                              <a
                                                href={
                                                  this.state.orderData
                                                    .pickUpRateConURL &&
                                                  this.state.orderData
                                                    .pickUpRateConURL
                                                }
                                              >
                                                <Button
                                                  style={{
                                                    float: "left",
                                                    marginTop: "20px",
                                                  }}
                                                  color="primary"
                                                  // onClick={this.requestPickUpSig}
                                                >
                                                  CONFIRM RATE
                                                </Button>
                                              </a>
                                            </div>
                                            <br />
                                            <div>
                                              {this.state.puLoadingDocuments
                                                ? "Loading Document..."
                                                : null}
                                              {this.state.puLoadingDocuments ? (
                                                <Check
                                                  style={{
                                                    color: this.state
                                                      .puDocumentsLoaded
                                                      ? "green"
                                                      : "initial",
                                                  }}
                                                />
                                              ) : null}
                                            </div>
                                          </div>
                                          <br />
                                          {/* <Button
                                          style={{ float: "left", marginTop: "20px" }}
                                          color="primary"
                                          onClick={() => this.confirmPickUpRate()}
                                        >Confirm Rate</Button> */}
                                        </GridItem>
                                      )}
                                      {(this.props.user.superAdmin ||
                                        this.props.user.vendorID ==
                                          this.state.orderData
                                            .vendorDropOffID) && (
                                        <GridItem xs={12} md={6}>
                                          Drop Off Rate for Vendor{" "}
                                          {this.state.orderData &&
                                            this.state.orderData
                                              .vendorDropOffName}
                                          <br />
                                          Rate: $
                                          {this.state.orderData &&
                                            this.state.orderData.dropOffRate}
                                          <br />
                                          Status:{" "}
                                          <span
                                            style={{
                                              color: this.state.orderData
                                                .dropOffRateConIsSigned
                                                ? "green"
                                                : "red",
                                            }}
                                          >
                                            {this.state.orderData
                                              .dropOffRateConIsSigned
                                              ? "confirmed"
                                              : "unconfirmed"}
                                          </span>
                                          <br />
                                          {/* <span style={{ color: (this.state.orderData && (this.state.orderData.dropOffRateStatus == "unconfirmed" ? (this.state.dropOffRateStatus == "confirmed" ? "green" : "red") : "green")) }}>{this.state.dropOffRateStatus && this.state.dropOffRateStatus} {this.state.dropOffRateStatus == "confirmed" ? null : ((this.state.orderData && !this.state.pickUpRateStatus) && this.state.orderData.dropOffRateStatus)}</span><br /> */}
                                          <a
                                            href={
                                              this.state.orderData
                                                .dropOffRateConURL &&
                                              this.state.orderData
                                                .dropOffRateConURL
                                            }
                                          >
                                            <Button
                                              style={{
                                                float: "left",
                                                marginTop: "20px",
                                              }}
                                              color="primary"
                                              // onClick={() => this.requestDropOffSig("https://app.hellosign.com/editor/embeddedSign?signature_id=71c325972757966f0cba57b16235b938&token=983e0536d29ee2d2004610dc5da82654")}
                                            >
                                              Confirm Rate
                                            </Button>
                                          </a>
                                          {this.state.doLoadingDocuments
                                            ? "Loading Document..."
                                            : null}
                                          {this.state.doLoadingDocuments ? (
                                            <Check
                                              style={{
                                                color: this.state
                                                  .doDocumentsLoaded
                                                  ? "green"
                                                  : "initial",
                                              }}
                                            />
                                          ) : null}
                                          <br />
                                          {/* {this.state.signatureURLLoaded &&
                                              <a href={this.state.signingURL} target="_blank"><Button style={{ float: "left", marginTop: "20px" }}
                                                color="info">SIGN CONFIRM
                              </Button></a>
                                            } */}
                                        </GridItem>
                                      )}
                                    </GridContainer>
                                  )}
                                </GridItem>
                              </GridContainer>
                            </GridItem>

                            <GridItem xs={12}>
                              {/* <Button
                                          style={{ float: "left", marginTop: "20px" }}
                                          color="primary"
                                          onClick={() => this.requestLTRSig("https://app.hellosign.com/editor/embeddedSign?signature_id=71c325972757966f0cba57b16235b938&token=983e0536d29ee2d2004610dc5da82654")}
                                        >LTR</Button> */}

                              {pathname == "/completed-orders" ? null : (
                                <div>
                                  <br />

                                  <b>Shipment Documents</b>
                                  {this.state.orderData && (
                                    <GridContainer>
                                      <GridItem xs={12} md={5}>
                                        <GridContainer>
                                          {/* {((this.props.user.superAdmin || (this.props.user.vendorID == this.state.orderData.vendorPickUpID)) && !this.state.orderData.driverPickUpRateConIsSigned) &&
                                              <GridItem xs={12}>
                                                <a href={this.state.orderData.driverPickUpRateConURL && this.state.orderData.driverPickUpRateConURL} target="_blank">
                                                  <Button
                                                    color="info"
                                                  >
                                                    SIGN PICK UP ALERT
                                                    </Button>
                                                </a>
                                              </GridItem>
                                            }
                                            {((this.props.user.superAdmin || (this.props.user.vendorID == this.state.orderData.vendorPickUpID)) && this.state.orderData.driverPickUpRateConIsSigned) &&
                                              <GridItem xs={12}>

                                                <a href={`https://api.eversign.com/api/download_current_document_status?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252&document_hash=${this.state.orderData.driverPickUpRateConHash}&audit_trail=1`} target="_blank">
                                                  <Button
                                                    color="success"
                                                  >
                                                    PRINT PICK UP ALERT
                                                </Button>
                                                </a>
                                              </GridItem>

                                            }
                                            {((this.props.user.superAdmin || (this.props.user.vendorID == this.state.orderData.vendorDropOffID)) && !this.state.orderData.driverDropOffRateIsSigned) &&
                                              <GridItem xs={12}>
                                                <a href={this.state.orderData.driverDropOffRateConURL && this.state.orderData.driverDropOffRateConURL} target="_blank">
                                                  <Button
                                                    color="info"
                                                  >
                                                    SIGN Drop Off Alert
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            }
                                            {((this.props.user.superAdmin || (this.props.user.vendorID == this.state.orderData.vendorDropOffID)) && this.state.orderData.driverDropOffRateIsSigned) &&
                                              <GridItem xs={12}>

                                                <a href={`https://api.eversign.com/api/download_current_document_status?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252&document_hash=${this.state.orderData.driverDropOffRateHash}&audit_trail=1`} target="_blank">
                                                  <Button
                                                    color="success"
                                                  >
                                                    PRINT DROP OFF ALERT
                                                    </Button>
                                                </a>
                                              </GridItem>

                                            } */}

                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorPickUpID) &&
                                            this.state.orderData
                                              .pickUpRateConHash && (
                                              <GridItem xs={12}>
                                                <a
                                                  href={`https://api.eversign.com/api/download_current_document_status?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252&document_hash=${
                                                    this.state.orderData
                                                      .pickUpRateConHash
                                                  }&audit_trail=1`}
                                                  target="_blank"
                                                >
                                                  <Button color="success">
                                                    {" "}
                                                    PRINT PICK UP RATE
                                                    CONFIRMATION
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}

                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorDropOffID) &&
                                            this.state.orderData
                                              .dropOffRateConHash && (
                                              <GridItem xs={12}>
                                                <a
                                                  href={`https://api.eversign.com/api/download_current_document_status?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252&document_hash=${
                                                    this.state.orderData
                                                      .dropOffRateConHash
                                                  }&audit_trail=1`}
                                                  target="_blank"
                                                >
                                                  <Button color="success">
                                                    {" "}
                                                    PRINT DROP OFF RATE
                                                    CONFIRMATION
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}
                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorPickUpID) &&
                                            !this.state.orderData
                                              .bolIsCompleted && (
                                              <GridItem xs={12}>
                                                <a
                                                  href={
                                                    this.state.orderData
                                                      .signingURLs &&
                                                    this.state.orderData
                                                      .signingURLs[1]
                                                  }
                                                  target="_blank"
                                                >
                                                  <Button color="info">
                                                    SIGN{" "}
                                                    {this.state.orderData
                                                      .deliveryType == "Air" ||
                                                    this.state.orderData
                                                      .deliveryType ==
                                                      "Scheduled Air"
                                                      ? "House Waybill"
                                                      : "Bill of Lading"}{" "}
                                                    AS DRIVER
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}
                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorPickUpID) &&
                                            !this.state.orderData
                                              .bolIsCompleted && (
                                              <GridItem xs={12}>
                                                <a
                                                  href={
                                                    this.state.orderData
                                                      .signingURLs &&
                                                    this.state.orderData
                                                      .signingURLs[0]
                                                  }
                                                  target="_blank"
                                                >
                                                  <Button color="info">
                                                    SIGN{" "}
                                                    {this.state.orderData
                                                      .deliveryType == "Air" ||
                                                    this.state.orderData
                                                      .deliveryType ==
                                                      "Scheduled Air"
                                                      ? "House Waybill"
                                                      : "Bill of Lading"}{" "}
                                                    AS SHIPPER
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}
                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorDropOffID) &&
                                            !this.state.orderData
                                              .bolIsCompleted && (
                                              <GridItem xs={12}>
                                                <a
                                                  target="_blank"
                                                  href={
                                                    this.state.orderData
                                                      .signingURLs &&
                                                    this.state.orderData
                                                      .signingURLs[2]
                                                  }
                                                >
                                                  <Button color="info">
                                                    SIGN{" "}
                                                    {this.state.orderData
                                                      .deliveryType == "Air" ||
                                                    this.state.orderData
                                                      .deliveryType ==
                                                      "Scheduled Air"
                                                      ? "House Waybill"
                                                      : "Bill of Lading"}{" "}
                                                    AS CONSIGNEE
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}
                                          <GridItem xs={12}>
                                            <a
                                              href={`https://api.eversign.com/api/download_current_document_status?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252&document_hash=${
                                                this.state.orderData.bolHash
                                              }&audit_trail=1`}
                                              target="_blank"
                                            >
                                              <Button color="success">
                                                {" "}
                                                PRINT{" "}
                                                {this.state.orderData
                                                  .deliveryType == "Air" ||
                                                this.state.orderData
                                                  .deliveryType ==
                                                  "Scheduled Air"
                                                  ? "House Waybill"
                                                  : "Bill of Lading"}
                                              </Button>
                                            </a>
                                          </GridItem>

                                          {/* <GridItem xs={12}>
                                              <a target='_blank' href={`http://cargo-rx-driver.web.app/pages/upload/${this.state.orderData.id}/pickup`}>
                                                <Button color='primary'>PU DRIVER APP</Button>
                                              </a>
                                            </GridItem>
                                            <GridItem xs={12}>
                                              <a target='_blank' href={`http://cargo-rx-driver.web.app/pages/upload/${this.state.orderData.id}/dropoff`}>
                                                <Button color='primary'>DO DRIVER APP</Button>
                                              </a>
                                            </GridItem> */}
                                          {/* {this.state.orderData.deliveryType == "Air"
                                            &&
                                            <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FAir%20Pick%20Up%20Rate%20Confirmation%20Final%203.3.2020.pdf?alt=media&token=e2206f0c-3117-4c95-a9e1-718aa813aee8" target="_blank">
                                              <Button
                                                color="primary"
                                              >
                                                Air Pickup Rate Confirmation
                                   </Button>
                                            </a>
                                          } */}
                                          {/* {(this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "LTL")
                                            &&
                                            <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FGround%20Only%20Rate%20Confirmation%20Final%203.3.2020.pdf?alt=media&token=f95662dd-c5ad-405f-a70a-0c8479a1faa9" target="_blank">
                                              <Button
                                                color="primary"
                                              >
                                                Ground Only Rate Confirmation
                                              </Button>
                                            </a>} */}
                                          {/* <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Shipper%20Air%20Pick%20Up%20Final%203.3.2020.pdf?alt=media&token=b9bf832c-4c5c-40b0-ac53-bab0b1bd2336" target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              Known Shipper Air Pick-Up Alert
                                   </Button>
                                          </a> */}
                                          {/* <a href={this.state.orderData.signingURLs && this.state.orderData.signingURLs[1]} target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              SIGN {(this.state.orderData.deliveryType == "Additional Options" || this.state.orderData.deliveryType == "Dedicated Ground") ? "Bill of Lading" : "House Waybill"}
                                            </Button>
                                          </a> */}
                                          {/* <a href={this.state.orderData.driverPickUpRateConURL && this.state.orderData.driverPickUpRateConURL} target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              Pick Up Rate
                                  </Button>
                                  </a> */}
                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorPickUpID) &&
                                            !this.state.orderData
                                              .sampleWayBillIsSigned && (
                                              <GridItem xs={12}>
                                                {(this.state.orderData
                                                  .deliveryType == "Air" ||
                                                  this.state.orderData
                                                    .deliveryType ==
                                                    "Scheduled Air") && (
                                                  <div>
                                                    {this.state.orderData
                                                      .signingSampleWayBill && (
                                                      <a
                                                        href={
                                                          this.state.orderData
                                                            .signingSampleWayBill
                                                        }
                                                        target="_blank"
                                                      >
                                                        <Button color="info">
                                                        View Sample Air Waybill
                                                        </Button>
                                                      </a>
                                                    )}
                                                  </div>
                                                )}
                                              </GridItem>
                                            )}
                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorPickUpID) &&
                                            this.state.orderData
                                              .sampleWayBillIsSigned && (
                                              <GridItem xs={12}>
                                                <div>
                                                  <a
                                                    href={`https://api.eversign.com/api/download_current_document_status?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252&document_hash=${
                                                      this.state.orderData
                                                        .sampleWayBillHash
                                                    }&audit_trail=1`}
                                                    target="_blank"
                                                  >
                                                    <Button color="success">
                                                      {" "}
                                                      PRINT SAMPLE WAYBILL
                                                    </Button>
                                                  </a>
                                                </div>
                                              </GridItem>
                                            )}

                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorPickUpID) && (
                                            <GridItem xs={12}>
                                              {!this.state.orderData.origin
                                                .ksms &&
                                                this.state.orderData
                                                  .driverIVFURL &&
                                                this.state.orderData
                                                  .deliveryType == "Air" &&
                                                !this.state.orderData
                                                  .driverIVFIsSigned && (
                                                  <a
                                                    href={
                                                      this.state.orderData
                                                        .driverIVFURL
                                                    }
                                                    target="_blank"
                                                  >
                                                    <Button color="info">
                                                      SIGN Shippers
                                                      Identification Validation
                                                    </Button>
                                                  </a>
                                                )}
                                            </GridItem>
                                          )}

                                          {/*    <a href={this.state.orderData.staticBOLURL && this.state.orderData.staticBOLURL} target="_blank">
                                      <Button
                                        color="info"
                                      >Static {(this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : "Bill of Lading"}</Button>
                                    </a>                                        <br/> */}

                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorPickUpID) && (
                                            <GridItem xs={12}>
                                              <div>
                                                {!this.state.orderData.origin
                                                  .ksms &&
                                                  this.state.orderData
                                                    .driverIVFURL &&
                                                  this.state.orderData
                                                    .deliveryType == "Air" &&
                                                  this.state.orderData
                                                    .driverIVFIsSigned && (
                                                    <a
                                                      href={`https://api.eversign.com/api/download_current_document_status?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252&document_hash=${
                                                        this.state.orderData
                                                          .driverIVF
                                                      }&audit_trail=1`}
                                                      target="_blank"
                                                    >
                                                      <Button color="success">
                                                        {" "}
                                                        PRINT Shippers
                                                        Identification
                                                        Validation
                                                      </Button>
                                                    </a>
                                                  )}
                                              </div>
                                            </GridItem>
                                          )}
                                          <br />

                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorPickUpID) && (
                                            <GridItem xs={12}>
                                              <a
                                                target="_blank"
                                                href={`http://cargo-rx-driver.web.app/pages/upload/${
                                                  this.state.orderData.id
                                                }/pickup`}
                                              >
                                                <Button color="primary">
                                                  PICK UP DRIVER APP
                                                </Button>
                                              </a>
                                            </GridItem>
                                          )}
                                          {(this.props.user.superAdmin ||
                                            this.props.user.vendorID ==
                                              this.state.orderData
                                                .vendorDropOffID) && (
                                            <GridItem xs={12}>
                                              <a
                                                target="_blank"
                                                href={`http://cargo-rx-driver.web.app/pages/upload/${
                                                  this.state.orderData.id
                                                }/dropoff`}
                                              >
                                                <Button color="primary">
                                                  DROP OFF DRIVER APP
                                                </Button>
                                              </a>
                                            </GridItem>
                                          )}
                                        </GridContainer>
                                        {/* <a href={`https://api.eversign.com/api/download_final_document?access_key=a74f3d4d2ca030cf60500f7814618064&business_id=141252&document_hash=${this.state.orderData.bolHash}&audit_trail=1`} target="_blank">
                                      <Button
                                        color="info"
                                      >Completed {(this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : "Bill of Lading"}</Button>
                                    </a> */}

                                        {/* <Button
                                          style={{ float: "left", marginTop: "20px" }}
                                          color="primary"
                                          onClick={() => this.requestWaybillSig("https://app.hellosign.com/editor/embeddedSign?signature_id=71c325972757966f0cba57b16235b938&token=983e0536d29ee2d2004610dc5da82654")}
                                        >House Waybill</Button> */}
                                        {/* <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FHouse%20Waybill%20Final%203.4.2020.pdf?alt=media&token=ffcb839a-def3-4ecc-a0f1-3f398aea160d" target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              House Waybill
                                   </Button>
                                          </a> */}
                                        <br />
                                        {this.state.orderData.deliveryType ==
                                          "Air" && (
                                          <a
                                            href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FHouse%20Waybill%20Final%203.4.2020.pdf?alt=media&token=ffcb839a-def3-4ecc-a0f1-3f398aea160d"
                                            target="_blank"
                                          >
                                            {/* <Button
                                              color="primary"
                                            >
                                              Airline Waybill
                                   </Button> */}
                                          </a>
                                        )}
                                        <br />
                                      </GridItem>
                                      {(this.props.user.superAdmin ||
                                        this.props.user.vendorID ==
                                          this.state.orderData
                                            .vendorPickUpID) && (
                                        <GridItem xs={12}>
                                          <b>Pick Up Driver Images</b>
                                          {(this.state.orderData.shipperBOL ||
                                            this.state.orderData
                                              .manualOriginAirlineWaybill) && (
                                            <GridContainer>
                                              {this.state.orderData
                                                .shipperBOL && (
                                                <GridItem xs={12}>
                                                  <a
                                                    href={
                                                      this.state.orderData
                                                        .shipperBOL[0].fileURL
                                                    }
                                                    target="_blank"
                                                  >
                                                    <Button color="primary">
                                                      HARD COPY BOL
                                                    </Button>
                                                  </a>
                                                </GridItem>
                                              )}
                                              {this.state.orderData
                                                .manualOriginAirlineWaybill && (
                                                <GridItem xs={12}>
                                                  <a
                                                    href={
                                                      this.state.orderData
                                                        .manualOriginAirlineWaybill[0]
                                                        .fileURL
                                                    }
                                                    target="_blank"
                                                  >
                                                    <Button color="primary">
                                                      ORIGIN AIRLINE DOCS
                                                    </Button>
                                                  </a>
                                                </GridItem>
                                              )}
                                            </GridContainer>
                                          )}
                                          <GridContainer>
                                            {this.state.orderData
                                              .freightPickUp && (
                                              <GridItem xs={12}>
                                                <GridContainer>
                                                  <GridItem xs={12}>
                                                    <b>
                                                      Freight Images at Pick up
                                                    </b>
                                                  </GridItem>

                                                  {this.state.orderData
                                                    .freightPickUp &&
                                                    this.state.orderData.freightPickUp.map(
                                                      (img) => (
                                                        <GridItem xs={3}>
                                                          <div
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <a
                                                              href={img.fileURL}
                                                              target="_blank"
                                                            >
                                                              <img
                                                                src={
                                                                  img.fileURL
                                                                }
                                                                style={{
                                                                  padding:
                                                                    "1px",
                                                                  width: "100%",
                                                                  border:
                                                                    "0.7px solid black",
                                                                  borderRadius:
                                                                    "5px",
                                                                }}
                                                              />
                                                            </a>
                                                          </div>
                                                        </GridItem>
                                                      )
                                                    )}
                                                </GridContainer>
                                              </GridItem>
                                            )}

                                            {this.state.orderData
                                              .freightDropOffAirline && (
                                              <GridItem xs={12}>
                                                <GridContainer>
                                                  <GridItem xs={12}>
                                                    <b>
                                                      Freight Images post tender
                                                    </b>
                                                  </GridItem>

                                                  {this.state.orderData
                                                    .freightDropOffAirline &&
                                                    this.state.orderData.freightDropOffAirline.map(
                                                      (img) => (
                                                        <GridItem xs={3}>
                                                          <div
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <a
                                                              href={img.fileURL}
                                                              target="_blank"
                                                            >
                                                              <img
                                                                src={
                                                                  img.fileURL
                                                                }
                                                                style={{
                                                                  padding:
                                                                    "1px",
                                                                  width: "100%",
                                                                  border:
                                                                    "0.7px solid black",
                                                                  borderRadius:
                                                                    "5px",
                                                                }}
                                                              />
                                                            </a>
                                                          </div>
                                                        </GridItem>
                                                      )
                                                    )}
                                                </GridContainer>
                                              </GridItem>
                                            )}
                                    {(this.state.orderData.deliveryType == "Additional Options" || this.state.orderData.deliveryType == "Ground") &&
                                               <div>
                                               {this.state.orderData
                                                 .consigneeBOL && (
                                                 <GridItem xs={12}>
                                                   <a
                                                     href={
                                                       this.state.orderData
                                                         .consigneeBOL[0].fileURL
                                                     }
                                                     target="_blank"
                                                   >
                                                     <Button color="primary">
                                                       HARD COPY POD
                                                     </Button>
                                                   </a>
                                                 </GridItem>
                                               )}
                                               {this.state.orderData
                                                 .freightDropOff && (
                                                 <GridItem xs={12}>
                                                   <GridContainer>
                                                     <GridItem xs={12}>
                                                       <b>
                                                         Freight Images at Delivery
                                                       </b>
                                                     </GridItem>
     
                                                     {this.state.orderData
                                                       .freightDropOff &&
                                                       this.state.orderData.freightDropOff.map(
                                                         (img) => (
                                                           <GridItem xs={3}>
                                                             <div
                                                               style={{
                                                                 width: "100%",
                                                               }}
                                                             >
                                                               <a
                                                                 href={img.fileURL}
                                                                 target="_blank"
                                                               >
                                                                 <img
                                                                   src={img.fileURL}
                                                                   style={{
                                                                     padding: "1px",
                                                                     width: "100%",
                                                                     border:
                                                                       "0.7px solid black",
                                                                     borderRadius:
                                                                       "5px",
                                                                   }}
                                                                 />
                                                               </a>
                                                             </div>
                                                           </GridItem>
                                                         )
                                                       )}
                                                   </GridContainer>
                                                 </GridItem>
                                               )}
                                             </div>
                                              }

                                          </GridContainer>
                                        </GridItem>
                                      )}

                                      {(this.props.user.superAdmin ||
                                        this.props.user.vendorID ==
                                          this.state.orderData
                                            .vendorDropOffID) && (
                                        <GridItem xs={12}>
                                          <br />
                                          <b>Delivery Driver Images</b>

                                          {(this.state.orderData.consigneeBOL ||
                                            this.state.orderData
                                              .manualDestinationAirlineWaybill) && (
                                            <GridContainer>
                                              {/* {this.state.orderData.consigneeBOL &&
                                                  <GridItem xs={12}>
                                                    <a href={this.state.orderData.consigneeBOL[0].fileURL} target='_blank'>
                                                      <Button color='primary'>
                                                        HARD COPY POD
                                                    </Button>
                                                    </a>
                                                  </GridItem>
                                                } */}
                                              {this.state.orderData
                                                .manualDestinationAirlineWaybill && (
                                                <GridItem xs={12}>
                                                  <a
                                                    href={
                                                      this.state.orderData
                                                        .manualDestinationAirlineWaybill[0]
                                                        .fileURL
                                                    }
                                                    target="_blank"
                                                  >
                                                    <Button color="primary">
                                                      DESTINATION AIRLINE DOCS
                                                    </Button>
                                                  </a>
                                                </GridItem>
                                              )}
                                            </GridContainer>
                                          )}
                                          <GridContainer>
                                            {this.state.orderData
                                              .freightPickUpAirport && (
                                              <GridItem xs={12}>
                                                <GridContainer>
                                                  <GridItem xs={12}>
                                                    <b>
                                                      Freight Images at Airline
                                                      Pick up
                                                    </b>
                                                  </GridItem>

                                                  {this.state.orderData
                                                    .freightPickUpAirport &&
                                                    this.state.orderData.freightPickUpAirport.map(
                                                      (img) => (
                                                        <GridItem xs={3}>
                                                          <div
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <a
                                                              href={img.fileURL}
                                                              target="_blank"
                                                            >
                                                              <img
                                                                src={
                                                                  img.fileURL
                                                                }
                                                                style={{
                                                                  padding:
                                                                    "1px",
                                                                  width: "100%",
                                                                  border:
                                                                    "0.7px solid black",
                                                                  borderRadius:
                                                                    "5px",
                                                                }}
                                                              />
                                                            </a>
                                                          </div>
                                                        </GridItem>
                                                      )
                                                    )}
                                                </GridContainer>
                                              </GridItem>
                                            )}

                                            {/* {this.state.orderData.freightDropOff &&
                                                <GridItem xs={12}>
                                                  <GridContainer>

                                                    <GridItem xs={12}><b>Freight Images at Delivery</b></GridItem>

                                                    {this.state.orderData.freightDropOff && this.state.orderData.freightDropOff.map(img => (
                                                      <GridItem xs={3}>
                                                        <div style={{ width: '100%' }}>
                                                          <a href={img.fileURL} target='_blank'>
                                                            <img src={img.fileURL} style={{ padding: '1px', width: '100%', border: '0.7px solid black', borderRadius: '5px' }} />
                                                          </a>
                                                        </div>
                                                      </GridItem>
                                                    ))}

                                                  </GridContainer>
                                                </GridItem>

                                              } */}
                                          </GridContainer>
                                        </GridItem>
                                      )}
                                      {this.props.user.vendorID ===
                                        this.state.orderData
                                          .vendorDropOffID && (
                                        <div>
                                          {this.state.orderData
                                            .consigneeBOL && (
                                            <GridItem xs={12}>
                                              <a
                                                href={
                                                  this.state.orderData
                                                    .consigneeBOL[0].fileURL
                                                }
                                                target="_blank"
                                              >
                                                <Button color="primary">
                                                  HARD COPY POD
                                                </Button>
                                              </a>
                                            </GridItem>
                                          )}
                                          {this.state.orderData
                                            .freightDropOff && (
                                            <GridItem xs={12}>
                                              <GridContainer>
                                                <GridItem xs={12}>
                                                  <b>
                                                    Freight Images at Delivery
                                                  </b>
                                                </GridItem>

                                                {this.state.orderData
                                                  .freightDropOff &&
                                                  this.state.orderData.freightDropOff.map(
                                                    (img) => (
                                                      <GridItem xs={3}>
                                                        <div
                                                          style={{
                                                            width: "100%",
                                                          }}
                                                        >
                                                          <a
                                                            href={img.fileURL}
                                                            target="_blank"
                                                          >
                                                            <img
                                                              src={img.fileURL}
                                                              style={{
                                                                padding: "1px",
                                                                width: "100%",
                                                                border:
                                                                  "0.7px solid black",
                                                                borderRadius:
                                                                  "5px",
                                                              }}
                                                            />
                                                          </a>
                                                        </div>
                                                      </GridItem>
                                                    )
                                                  )}
                                              </GridContainer>
                                            </GridItem>
                                          )}
                                        </div>
                                      )}
                                      {this.props.user.vendorID ===
                                        this.state.orderData.vendorPickUpID && (
                                        <GridItem xs={12} md={6}>
                                          {console.log(
                                            this.props.user.vendorID ===
                                              this.state.orderData
                                                .vendorDropOffID
                                          )}
                                          {/* {((this.props.user.vendorID === this.state.orderData.vendorDropOffID) || (this.props.user.vendorID === this.state.orderData.vendorPickUpID)) && ( */}
                                          <React.Fragment>
                                            Vendor Pick Up Chat
                                            <br />
                                            <br />
                                            <Chat
                                              orderID={this.state.orderData.id}
                                              channel={"vendorPickUp"}
                                            />
                                          </React.Fragment>
                                          {/* )} */}
                                        </GridItem>
                                      )}
                                      {this.props.user.vendorID ===
                                        this.state.orderData
                                          .vendorDropOffID && (
                                        <GridItem xs={12} md={6}>
                                          {console.log(
                                            this.props.user.vendorID ===
                                              this.state.orderData
                                                .vendorDropOffID
                                          )}
                                          {/* {((this.props.user.vendorID === this.state.orderData.vendorDropOffID) || (this.props.user.vendorID === this.state.orderData.vendorPickUpID)) && ( */}
                                          <React.Fragment>
                                            Vendor Drop Off Chat
                                            <br />
                                            <br />
                                            <Chat
                                              orderID={this.state.orderData.id}
                                              channel={"vendorDropOff"}
                                            />
                                          </React.Fragment>
                                          {/* )} */}
                                        </GridItem>
                                      )}
                                    </GridContainer>
                                  )}
                                </div>
                              )}
                            </GridItem>
                          </GridContainer>
                          <br />
                          <br />
                          {pathname == "/completed-orders" ? (
                            <div>
                              <h3 style={{}}>
                                <b>Delivery Information</b>
                              </h3>
                              CONDITION:{" "}
                              <b>
                                {this.state.orderData &&
                                  this.state.orderData.CONDITION}
                              </b>
                              <br />
                              POD:{" "}
                              {this.state.orderData &&
                                this.state.orderData.BOLPICS.map((item) => (
                                  <a
                                    style={{ color: "#ff0000 !important" }}
                                    href={item}
                                    target="_blank"
                                  >
                                    Click here for image
                                  </a>
                                ))}
                              <br />
                              {this.state.orderData && (
                                <div>
                                  DAMAGE:{" "}
                                  {this.state.orderData.DAMAGEPIC &&
                                    this.state.orderData.DAMAGEPICS.map(
                                      (item) => (
                                        <a
                                          style={{
                                            color: "#ff0000 !important",
                                          }}
                                          href={item}
                                          target="_blank"
                                        >
                                          Click here for image
                                        </a>
                                      )
                                    )}
                                </div>
                              )}
                            </div>
                          ) : null}
                        </React.Fragment>
                      ) : null}
                      <br />
                    </GridItem>
                  </GridContainer>
                </form>
              </div>
              {/* TOC MODAL */}
              <Dialog
                classes={{
                  root: classes.modalRoot,
                  paper: classes.modal + " " + classes.modalLarge,
                }}
                open={this.state.eSigModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("eSigModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  <GridContainer justify="center">
                    <GridItem xs={3}>
                      {!this.state.signatureURLLoaded && (
                        <img
                          src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2Fgiphy.gif?alt=media&token=d6a97d72-f88a-44eb-bc07-f25b0a190eaf"
                          width="100%"
                        />
                      )}
                    </GridItem>
                  </GridContainer>

                  {this.state.signatureURLLoaded && (
                    <Iframe
                      url={this.state.signingURL}
                      width="100%"
                      height="1000px"
                      id="myId"
                      className="myClassname"
                      display="initial"
                      position="relative"
                    />
                  )}
                </DialogContent>
              </Dialog>
            </GridItem>
          </GridContainer>
        )}
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  //console.log(state)
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
    orderID: ownProps.match.params.id,
  };
};

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(Form);



// WEBPACK FOOTER //
// ./src/views/Orders/OrdersDetails.jsx